<template>
  <div id="app">
    <header class="header">
      <h1>Vue 2.0 Ant Vue2</h1>
      <p>兼容 Ant Design Vue 组件库</p>
    </header>
    <main class="main">

      <!-- 边框组件 -->
      <div class="section">
        <h2 class="section-title">边框组件 Border 演示</h2>
        
        <div class="demo-section">
          <div class="demo-title">实线边框</div>
          <div class="demo-box">
            <div class="border-item border-solid-default">实线边框</div>
            <div class="border-item border-solid-primary">主色边框</div>
            <div class="border-item border-solid-success">成功边框</div>
            <div class="border-item border-solid-warning">警告边框</div>
            <div class="border-item border-solid-danger">危险边框</div>
          </div>
        </div>
        
        <div class="demo-section">
          <div class="demo-title">虚线边框</div>
          <div class="demo-box">
            <div class="border-item border-dashed-default">虚线边框</div>
            <div class="border-item border-dashed-primary">主色虚线</div>
            <div class="border-item border-dashed-success">成功虚线</div>
          </div>
        </div>
        
        <div class="demo-section">
          <div class="demo-title">圆角分类</div>
          <div class="demo-box">
            <div class="border-item border-radius-none">无圆角</div>
            <div class="border-item border-radius-small">小圆角</div>
            <div class="border-item border-radius-medium">中圆角</div>
            <div class="border-item border-radius-large">大圆角</div>
            <div class="border-item border-radius-full">全圆角</div>
          </div>
        </div>
        
        <div class="demo-section">
          <div class="demo-title">阴影分类</div>
          <div class="demo-box">
            <div class="border-item border-shadow-none">无阴影</div>
            <div class="border-item border-shadow-small">小阴影</div>
            <div class="border-item border-shadow-medium">中阴影</div>
            <div class="border-item border-shadow-large">大阴影</div>
          </div>
        </div>
      </div>

      <!-- 颜色规范 -->
      <div class="section">
        <h2 class="section-title">颜色规范</h2>
        
        <div class="demo-section">
          <div class="demo-title">品牌色</div>
          <div class="demo-box">
            <div class="color-card">
              <div class="color-preview" style="background-color: #FC6732;"></div>
              <div class="color-info">
                <div class="color-name">品牌色</div>
                <div class="color-hex">#FC6732</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #FC7647;"></div>
              <div class="color-info">
                <div class="color-name">悬停色</div>
                <div class="color-hex">#FC7647</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #E35D2D;"></div>
              <div class="color-info">
                <div class="color-name">点击色</div>
                <div class="color-hex">#E35D2D</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #FFF0EB;"></div>
              <div class="color-info">
                <div class="color-name">选中背景色</div>
                <div class="color-hex">#FFF0EB</div>
              </div>
            </div>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">功能色</div>
          <div class="demo-box">
            <div class="color-card">
              <div class="color-preview" style="background-color: #FD5451;"></div>
              <div class="color-info">
                <div class="color-name">警示色</div>
                <div class="color-hex">#FD5451</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #0DD78D;"></div>
              <div class="color-info">
                <div class="color-name">成功色</div>
                <div class="color-hex">#0DD78D</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #FEAE4D;"></div>
              <div class="color-info">
                <div class="color-name">提示色</div>
                <div class="color-hex">#FEAE4D</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #516EFD;"></div>
              <div class="color-info">
                <div class="color-name">链接色</div>
                <div class="color-hex">#516EFD</div>
              </div>
            </div>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">文字色</div>
          <div class="demo-box">
            <div class="color-card">
              <div class="color-preview" style="background-color: #1B1C33;"></div>
              <div class="color-info">
                <div class="color-name">标题色</div>
                <div class="color-hex">#1B1C33</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #1B1C33;"></div>
              <div class="color-info">
                <div class="color-name">正文色</div>
                <div class="color-hex">#1B1C33</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #8D8E99;"></div>
              <div class="color-info">
                <div class="color-name">辅助色</div>
                <div class="color-hex">#8D8E99</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #B0B1B8;"></div>
              <div class="color-info">
                <div class="color-name">禁用色</div>
                <div class="color-hex">#B0B1B8</div>
              </div>
            </div>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">边框与背景</div>
          <div class="demo-box">
            <div class="color-card">
              <div class="color-preview" style="background-color: #D7D7DB;"></div>
              <div class="color-info">
                <div class="color-name">边框色</div>
                <div class="color-hex">#D7D7DB</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #EDEDF0;"></div>
              <div class="color-info">
                <div class="color-name">分割线色</div>
                <div class="color-hex">#EDEDF0</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #E8E9EB;"></div>
              <div class="color-info">
                <div class="color-name">背景色</div>
                <div class="color-hex">#E8E9EB</div>
              </div>
            </div>
            <div class="color-card">
              <div class="color-preview" style="background-color: #F7F8FA;"></div>
              <div class="color-info">
                <div class="color-name">表头背景色</div>
                <div class="color-hex">#F7F8FA</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 字体规范 -->
      <div class="section">
        <h2 class="section-title">字体规范</h2>
        <div class="demo-section">
          <div class="demo-title">字号/字重规范</div>
          <div class="demo-box">
            <table class="spec-table">
              <thead>
                <tr>
                  <th>字体</th>
                  <th>字号</th>
                  <th>字重</th>
                  <th>说明</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span class="spec-label">PingFangSC</span></td>
                  <td><span class="spec-value">24px</span></td>
                  <td><span class="spec-value">600</span></td>
                  <td><span style="font-size: 24px; font-weight: 600; color: #1B1C33;">重要数据</span></td>
                </tr>
                <tr>
                  <td><span class="spec-label">PingFangSC</span></td>
                  <td><span class="spec-value">18px</span></td>
                  <td><span class="spec-value">600</span></td>
                  <td><span style="font-size: 18px; font-weight: 600; color: #1B1C33;">页面主标题</span></td>
                </tr>
                <tr>
                  <td><span class="spec-label">PingFangSC</span></td>
                  <td><span class="spec-value">16px</span></td>
                  <td><span class="spec-value">600</span></td>
                  <td><span style="font-size: 16px; font-weight: 600; color: #1B1C33;">卡片标题、二级标题</span></td>
                </tr>
                <tr>
                  <td><span class="spec-label">PingFangSC</span></td>
                  <td><span class="spec-value">14px</span></td>
                  <td><span class="spec-value">600</span></td>
                  <td><span style="font-size: 14px; font-weight: 600; color: #1B1C33;">三级标题</span></td>
                </tr>
                <tr>
                  <td><span class="spec-label">PingFangSC</span></td>
                  <td><span class="spec-value">14px</span></td>
                  <td><span class="spec-value">400</span></td>
                  <td><span style="font-size: 14px; font-weight: 400; color: #1B1C33;">正文内容</span></td>
                </tr>
                <tr>
                  <td><span class="spec-label">PingFangSC</span></td>
                  <td><span class="spec-value">12px</span></td>
                  <td><span class="spec-value">400</span></td>
                  <td><span style="font-size: 12px; font-weight: 400; color: #8D8E99;">辅助说明、提示信息</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 间距规范 -->
      <div class="section">
        <h2 class="section-title">间距规范</h2>
        <div class="demo-section">
          <div class="demo-title">基础间距（8px倍数）</div>
          <div class="demo-box">
            <table class="spec-table">
              <thead>
                <tr>
                  <th>属性</th>
                  <th>值</th>
                  <th>示例</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span class="spec-label">基础间距</span></td>
                  <td><span class="spec-value">8px 倍数</span></td>
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <div class="spacing-box" style="width: 8px; height: 20px;">8</div>
                      <div class="spacing-box" style="width: 16px; height: 20px;">16</div>
                      <div class="spacing-box" style="width: 24px; height: 20px;">24</div>
                      <div class="spacing-box" style="width: 32px; height: 20px;">32</div>
                      <div class="spacing-box" style="width: 40px; height: 20px;">40</div>
                      <div class="spacing-box" style="width: 48px; height: 20px;">48</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 按钮组件 -->
      <div class="section">
        <h2 class="section-title">按钮 Button 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础按钮</div>
          <div class="demo-box">
            <!-- 次要按钮 -->
            <a-button>次要按钮</a-button>
            <!-- 主要按钮 -->
            <a-button type="primary">主要按钮</a-button>
            <!-- 文字按钮 -->
            <a-button type="text">文字按钮</a-button>
            <!-- 链接按钮 -->
            <a-button type="link">链接按钮</a-button>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">图标按钮</div>
          <div class="demo-box">
            <a-button type="primary" icon="plus">新增</a-button>
            <a-button icon="search">搜索</a-button>
            <a-button icon="upload">上传</a-button>
            <a-button icon="delete">删除</a-button>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">按钮状态</div>
          <div class="demo-box">
            <a-button type="primary" :loading="buttonLoading">加载中</a-button>
            <a-button disabled>禁用</a-button>
          </div>
        </div>
      </div>

      <!-- 输入框组件 -->
      <div class="section">
        <h2 class="section-title">输入框 Input 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础输入框</div>
          <div class="demo-box">
            <a-input v-model="inputValue" placeholder="请输入内容" style="width: 300px;" />
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">带前缀图标</div>
          <div class="demo-box">
            <a-input-search v-model="inputValue" placeholder="请输入搜索内容" style="width: 300px;" />
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">密码输入框</div>
          <div class="demo-box">
            <a-input-password v-model="inputValue" placeholder="请输入密码" style="width: 300px;" />
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">文本域</div>
          <div class="demo-box">
            <a-textarea v-model="textareaValue" placeholder="请输入多行文本" :rows="3" style="width: 400px;" />
          </div>
        </div>
      </div>

      <!-- 选择器组件 -->
      <div class="section">
        <h2 class="section-title">选择器 Select 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础选择器</div>
          <div class="demo-box">
            <a-select v-model="selectValue" placeholder="请选择" style="width: 200px;">
              <a-select-option value="option1">选项一</a-select-option>
              <a-select-option value="option2">选项二</a-select-option>
              <a-select-option value="option3">选项三</a-select-option>
            </a-select>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">多选选择器</div>
          <div class="demo-box">
            <a-select v-model="multiSelectValue" mode="multiple" placeholder="请选择" style="width: 400px;">
              <a-select-option value="option1">选项一</a-select-option>
              <a-select-option value="option2">选项二</a-select-option>
              <a-select-option value="option3">选项三</a-select-option>
              <a-select-option value="option4">选项四</a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <!-- 级联选择器 -->
      <div class="section">
        <h2 class="section-title">级联选择器 Cascader 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础/仅叶子/多选</div>
          <div class="demo-box">
            <a-cascader v-model="cascaderValue" :options="cascaderOptions" placeholder="请选择" style="width: 200px;" />
            <a-cascader v-model="cascaderValueLeaf" :options="cascaderOptions" :show-search="{ filter: cascaderFilter }" placeholder="仅叶子" style="width: 200px;" />
            <a-cascader v-model="cascaderValueMulti" :options="cascaderOptions" mode="multiple" placeholder="多选" style="width: 250px;" />
          </div>
        </div>
      </div>

      <!-- 单选框和复选框 -->
      <div class="section">
        <h2 class="section-title">单选框 & 复选框演示</h2>

        <div class="demo-section">
          <div class="demo-title">单选框</div>
          <div class="demo-box">
            <a-radio-group v-model="radioValue">
              <a-radio value="1">选项一</a-radio>
              <a-radio value="2">选项二</a-radio>
              <a-radio value="3">选项三</a-radio>
            </a-radio-group>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">带边框的单选框</div>
          <div class="demo-box">
            <a-radio-group v-model="radioValue">
              <a-radio value="1" border class="bordered-radio">选项一</a-radio>
              <a-radio value="2" border class="bordered-radio">选项二</a-radio>
              <a-radio value="3" border class="bordered-radio">选项三</a-radio>
            </a-radio-group>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">复选框</div>
          <div class="demo-box">
            <a-checkbox-group v-model="checkboxList">
              <a-checkbox value="checkbox1">复选一</a-checkbox>
              <a-checkbox value="checkbox2">复选二</a-checkbox>
              <a-checkbox value="checkbox3">复选三</a-checkbox>
            </a-checkbox-group>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">带边框的复选框</div>
          <div class="demo-box">
            <a-checkbox-group v-model="checkboxList">
              <a-checkbox value="checkbox1" border class="bordered-checkbox">复选一</a-checkbox>
              <a-checkbox value="checkbox2" border class="bordered-checkbox">复选二</a-checkbox>
              <a-checkbox value="checkbox3" border class="bordered-checkbox">复选三</a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
      </div>

      <!-- 开关组件 -->
      <div class="section">
        <h2 class="section-title">开关 Switch 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础文字开关</div>
          <div class="demo-box">
            <a-switch v-model="switchValue" checked-children="开启" un-checked-children="关闭" />
            <a-switch v-model="switchValue2" checked-children="是" un-checked-children="否" disabled />
          </div>
        </div>
      </div>

      <!-- 数字输入框 -->
      <div class="section">
        <h2 class="section-title">数字输入框 InputNumber 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础/步进/限制</div>
          <div class="demo-box">
            <a-input-number v-model="inputNumberValue" :min="1" :max="100" style="width: 150px;" />
            <a-input-number v-model="inputNumberValue2" :step="2" :step-strictly="true" style="width: 150px;" />
            <a-input-number v-model="inputNumberValue3" :precision="2" :min="0" :max="100" style="width: 150px;" />
          </div>
        </div>
      </div>

      <!-- 评分组件 -->
      <div class="section">
        <h2 class="section-title">评分 Rate 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础评分</div>
          <div class="demo-box">
            <a-rate v-model="rateValue" />
          </div>
        </div>
      </div>

      <!-- 滑块组件 -->
      <div class="section">
        <h2 class="section-title">滑块 Slider 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础滑块</div>
          <div class="demo-box">
            <a-slider v-model="sliderValue" :marks="sliderMarks" style="width: 400px;" />
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">范围滑块</div>
          <div class="demo-box">
            <a-slider range v-model="sliderRange" style="width: 400px;" />
          </div>
        </div>
      </div>

      <!-- 颜色选择器 -->
      <div class="section">
        <h2 class="section-title">颜色选择器 ColorPicker 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础</div>
          <div class="demo-box">
            <div class="color-picker-wrapper">
              <input type="color" v-model="colorValue" class="color-picker-input" />
              <span class="color-picker-value">{{ colorValue }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 上传组件 -->
      <div class="section">
        <h2 class="section-title">上传组件 Upload 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础上传</div>
          <div class="demo-box" style="width: 100%;">
            <a-upload
              :file-list="fileList"
              :before-upload="beforeUpload"
              @change="handleChange"
            >
              <a-button type="primary"><a-icon type="upload" /> 点击上传</a-button>
            </a-upload>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">拖拽上传</div>
          <div class="demo-box">
            <a-upload-dragger
              name="file"
              :file-list="fileListDrag"
              :before-upload="beforeUploadDrag"
              @change="handleChangeDrag"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" style="color: #FC6732;" />
              </p>
              <p class="ant-upload-text">将文件拖到此处或<em>点击上传</em></p>
              <p class="ant-upload-hint">jpg/png 文件大小不超过 500kb</p>
            </a-upload-dragger>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">文件列表-图片</div>
          <div class="demo-box" style="width: 100%;">
            <a-upload
              :file-list="fileListImage"
              list-type="picture"
              :before-upload="beforeUploadImage"
              @change="handleChangeImage"
            >
              <a-button type="primary" size="small"><a-icon type="upload" /> 点击上传</a-button>
            </a-upload>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">照片墙</div>
          <div class="demo-box" style="width: 100%;">
            <a-upload
              :file-list="fileListWall"
              list-type="picture-card"
              @preview="handlePreviewWall"
              @change="handleChangeWall"
            >
              <div v-if="fileListWall.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </div>
      </div>

      <!-- 时间选择器 -->
      <div class="section">
        <h2 class="section-title">时间选择器 TimePicker 演示</h2>
        <a-config-provider :locale="zhCN">
          <div class="demo-section">
            <div class="demo-title">基础/禁用/只读/范围</div>
            <div class="demo-box">
              <a-time-picker v-model="timeValue" placeholder="选择时间" style="width: 150px;" />
              <a-time-picker v-model="timeValue" placeholder="选择时间" disabled style="width: 150px;" />
              <a-time-picker v-model="timeValue" placeholder="选择时间" readonly style="width: 150px;" />
              <a-range-picker v-model="timeRangeValue" :show-time="{ format: 'HH:mm:ss' }" format="YYYY-MM-DD HH:mm:ss" style="width: 320px;" />
            </div>
          </div>
        </a-config-provider>
      </div>

      <!-- 日期选择器 -->
      <div class="section">
        <h2 class="section-title">日期选择器 DatePicker 演示</h2>
        <a-config-provider :locale="zhCN">
          <div class="demo-section">
            <div class="demo-title">基础/周/月/范围</div>
            <div class="demo-box">
              <a-date-picker v-model="dateValue" placeholder="选择日期" style="width: 150px;" />
              <a-week-picker v-model="weekValue" placeholder="选择周" style="width: 150px;" />
              <a-month-picker v-model="monthValue" placeholder="选择月" style="width: 150px;" />
              <a-range-picker v-model="dateRangeValue" style="width: 250px;" />
            </div>
          </div>
        </a-config-provider>
      </div>

      <!-- 结果组件 -->
      <div class="section">
        <h2 class="section-title">结果组件 Result 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础用法</div>
          <div class="demo-box" style="display: block;">
            <a-row :gutter="16">
              <a-col :span="6">
                <a-result title="主要提示" sub-title="请按照提示操作">
                  <template #icon>
                    <a-icon type="exclamation-circle" style="font-size: 48px; color: #FC6732;" />
                  </template>
                  <template #extra>
                    <a-button type="primary">返回</a-button>
                  </template>
                </a-result>
              </a-col>
              <a-col :span="6">
                <a-result title="成功提示" sub-title="请按照提示操作" status="success">
                  <template #extra>
                    <a-button type="primary">返回</a-button>
                  </template>
                </a-result>
              </a-col>
              <a-col :span="6">
                <a-result title="警告提示" sub-title="请按照提示操作" status="warning">
                  <template #extra>
                    <a-button type="primary">返回</a-button>
                  </template>
                </a-result>
              </a-col>
              <a-col :span="6">
                <a-result title="错误提示" sub-title="请按照提示操作" status="error">
                  <template #extra>
                    <a-button type="primary">返回</a-button>
                  </template>
                </a-result>
              </a-col>
              <a-col :span="6">
                <a-result title="信息提示" sub-title="请按照提示操作">
                  <template #icon>
                    <a-icon type="info-circle" style="font-size: 48px; color: #516EFD;" />
                  </template>
                  <template #extra>
                    <a-button type="primary">返回</a-button>
                  </template>
                </a-result>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>

      <!-- 穿梭组件 -->
      <div class="section">
        <h2 class="section-title">穿梭组件 Transfer 演示</h2>
        <div class="demo-section">
          <div class="demo-title">高级穿梭组件（支持统计、搜索、拖动排序）</div>
          <div class="demo-box" style="align-items: center;">
            <!-- 左侧：可选列表 -->
            <div class="transfer-panel">
              <div class="transfer-panel-header">
                <span>可选 ({{ leftCount }})</span>
              </div>
              <div class="transfer-panel-search">
                <a-input v-model="transferSearchLeft" placeholder="请输入搜索内容" size="small" allow-clear />
              </div>
              <div class="transfer-panel-body">
                <div 
                  v-for="item in filteredLeftData" 
                  :key="item.key"
                  class="transfer-panel-item"
                  @click="addItem(item.key)"
                >
                  <span>{{ item.label }}</span>
                  <span style="color: #FC6732;">→</span>
                </div>
                <div v-if="filteredLeftData.length === 0" class="transfer-empty">无数据</div>
              </div>
            </div>
            
            <!-- 中间：操作按钮 -->
            <div class="transfer-buttons">
              <a-button type="primary" size="small" @click="addAllItems">≫</a-button>
              <a-button type="primary" size="small" @click="removeAllItems">≪</a-button>
            </div>
            
            <!-- 右侧：已选列表（支持拖拽排序） -->
            <div class="transfer-panel">
              <div class="transfer-panel-header">
                <span>已选 ({{ rightCount }})</span>
              </div>
              <div class="transfer-panel-search">
                <a-input v-model="transferSearchRight" placeholder="请输入搜索内容" size="small" allow-clear />
              </div>
              <div class="transfer-panel-body">
                <div 
                  v-for="(item, index) in filteredRightData" 
                  :key="item.key"
                  class="transfer-panel-item draggable"
                  draggable="true"
                  @dragstart="onDragStart($event, index)"
                  @dragover.prevent
                  @drop="onDrop($event, index)"
                >
                  <span class="drag-handle">☰</span>
                  <span class="item-label">{{ item.label }}</span>
                  <div class="item-actions">
                    <a-icon type="up" class="sort-arrow" v-if="index > 0" @click.stop="moveUp(index)" />
                    <a-icon type="down" class="sort-arrow" v-if="index < filteredRightData.length - 1" @click.stop="moveDown(index)" />
                    <span class="remove-btn" @click.stop="removeItem(item.key)">✕</span>
                  </div>
                </div>
                <div v-if="filteredRightData.length === 0" class="transfer-empty">无数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 筛选条件 -->
      <div class="section">
        <h2 class="section-title">筛选条件 Filter 演示</h2>
        <div class="demo-section">
          <div class="demo-title">可展开收起筛选</div>
          <div class="filter-container">
            <!-- 收起时：显示第一行字段 -->
            <template v-if="!filterExpanded">
              <a-row :gutter="16" style="margin-bottom: 16px;">
                <a-col :span="field.type === 'daterange' ? 12 : 6" v-for="field in filterFieldRows[0]" :key="field.field">
                  <template v-if="field.type === 'input'">
                    <a-input v-model="filterData[field.field]" :placeholder="field.placeholder" allow-clear />
                  </template>
                  <template v-else-if="field.type === 'select'">
                    <a-select v-model="filterData[field.field]" :placeholder="field.placeholder" allow-clear style="width: 100%;">
                      <a-select-option v-for="opt in field.options" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                    </a-select>
                  </template>
                  <template v-else-if="field.type === 'daterange'">
                    <a-range-picker v-model="filterData[field.field]" :placeholder="['开始日期', '结束日期']" style="width: 100%;" />
                  </template>
                </a-col>
              </a-row>
            </template>
            <!-- 展开时：显示所有字段（按行） -->
            <template v-else>
              <a-row :gutter="16" v-for="(row, rowIndex) in filterFieldRows" :key="rowIndex" style="margin-bottom: 16px;">
                <a-col :span="field.type === 'daterange' ? 12 : 6" v-for="field in row" :key="field.field">
                  <template v-if="field.type === 'input'">
                    <a-input v-model="filterData[field.field]" :placeholder="field.placeholder" allow-clear />
                  </template>
                  <template v-else-if="field.type === 'select'">
                    <a-select v-model="filterData[field.field]" :placeholder="field.placeholder" allow-clear style="width: 100%;">
                      <a-select-option v-for="opt in field.options" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                    </a-select>
                  </template>
                  <template v-else-if="field.type === 'daterange'">
                    <a-range-picker v-model="filterData[field.field]" :placeholder="['开始日期', '结束日期']" style="width: 100%;" />
                  </template>
                </a-col>
              </a-row>
            </template>
            <!-- 按钮组（嵌入到带文案分割线的文案位置） -->
            <a-divider class="filter-divider">
              <div class="filter-actions">
                <a-button type="primary" @click="doFilter">查询</a-button>
                <a-button @click="resetFilter">重置</a-button>
                <a-divider type="vertical" />
                <a-button type="text" @click="filterExpanded = !filterExpanded" style="padding: 0;">
                  {{ filterExpanded ? '收起' : '展开' }}<span style="margin-left: 4px; font-size: 12px;">{{ filterExpanded ? '▲' : '▼' }}</span>
                </a-button>
                <a-divider type="vertical" />
                <a-button type="text" @click="openFilterConfig" style="padding: 0;">高级筛选</a-button>
              </div>
            </a-divider>
          </div>
          <div class="filter-footer" v-if="false">
            <a-divider type="vertical" />
            <a-button type="text" size="small" @click="filterExpanded = !filterExpanded" style="padding: 0;">
              {{ filterExpanded ? '收起' : '展开' }}<span style="margin-left: 4px; font-size: 12px;">{{ filterExpanded ? '▲' : '▼' }}</span>
            </a-button>
            <a-divider type="vertical" />
            <a-button type="text" size="small" @click="openFilterConfig" style="padding: 0;">高级筛选</a-button>
          </div>
        </div>
      </div>
      
      <!-- 高级筛选弹窗 -->
      <a-modal v-model="filterConfigVisible" title="高级筛选配置" width="700px">
        <div class="dialog-container">
          <div style="margin-bottom: 16px; display: flex; justify-content: space-between; align-items: center;">
            <span>选择要显示的筛选字段：</span>
            <a-button type="primary" size="small" @click="showSaveTemplate = true; templateName = ''">保存当前配置为模板</a-button>
          </div>
          <div class="demo-box no-border" style="align-items: center; justify-content: center; gap: 16px;">
            <div class="transfer-panel">
              <div class="transfer-panel-header">
                <span>可选 ({{ filterLeftCount }})</span>
              </div>
              <div class="transfer-panel-search">
                <a-input v-model="filterSearchLeft" placeholder="请输入搜索内容" size="small" allow-clear />
              </div>
              <div class="transfer-panel-body">
                <div v-for="field in filterFilteredLeftData" :key="field.field" class="transfer-panel-item" @click="addFilterField(field.field)">
                  <span>{{ field.label }}</span>
                  <span style="color: #FC6732;">→</span>
                </div>
                <div v-if="filterFilteredLeftData.length === 0" class="transfer-empty">无数据</div>
              </div>
            </div>
            <div class="transfer-buttons">
              <a-button type="primary" size="small" @click="addAllFilterFields">≫</a-button>
              <a-button type="primary" size="small" :disabled="filterRightCount <= 1" @click="removeAllFilterFields">≪</a-button>
            </div>
            <div class="transfer-panel">
              <div class="transfer-panel-header">
                <span>已选 ({{ filterRightCount }})</span>
              </div>
              <div class="transfer-panel-search">
                <a-input v-model="filterSearchRight" placeholder="请输入搜索内容" size="small" allow-clear />
              </div>
              <div class="transfer-panel-body">
                <div 
                  v-for="(field, index) in filterFilteredRightData" 
                  :key="field.field"
                  class="transfer-panel-item draggable"
                  draggable="true"
                  @dragstart="onFilterDragStart($event, index)"
                  @dragover.prevent
                  @drop="onFilterDrop($event, index)"
                >
                  <span class="drag-handle">☰</span>
                  <span class="item-label">{{ field.label }}</span>
                  <div class="item-actions">
                    <a-icon type="up" class="sort-arrow" v-if="index > 0" @click.stop="moveFilterFieldUp(index)" />
                    <a-icon type="down" class="sort-arrow" v-if="index < filterFilteredRightData.length - 1" @click.stop="moveFilterFieldDown(index)" />
                    <span class="remove-btn" :class="{ disabled: filterRightCount <= 1 }" @click.stop="filterRightCount > 1 ? removeFilterField(field.field) : null">✕</span>
                  </div>
                </div>
                <div v-if="filterFilteredRightData.length === 0" class="transfer-empty">无数据</div>
              </div>
            </div>
          </div>
          <!-- 模板列表 -->
          <div style="margin-top: 20px; padding-top: 16px; border-top: 1px solid #e4e7ed;">
            <div style="margin-bottom: 12px;">
              <span>我的模板：</span>
            </div>
            <div v-if="tempFilterTemplates.length === 0" style="color: #909399; font-size: 13px; padding: 12px 0;">暂无保存的模板</div>
            <div v-else>
              <div v-for="(template, idx) in tempFilterTemplates" :key="idx" class="template-item">
                <span class="template-name" @click="applyTemplate(template)">{{ template.name }}</span>
                <div class="template-actions">
                  <a-icon type="edit" class="template-edit-btn" @click="editTemplate(idx)" />
                  <a-icon type="delete" class="template-delete-btn" @click="deleteTemplate(idx)" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <a-button @click="filterConfigVisible = false">取消</a-button>
          <a-button type="primary" @click="applyFilterConfig">确定</a-button>
        </div>
      </a-modal>
      
      <!-- 保存模板弹窗（仅输入名称） -->
      <a-modal v-model="showSaveTemplate" title="保存筛选模板" width="400px" @cancel="cancelSaveTemplate">
        <div class="dialog-container">
          <a-input v-model="templateName" placeholder="请输入模板名称" />
        </div>
        <div slot="footer">
          <a-button @click="cancelSaveTemplate">取消</a-button>
          <a-button type="primary" @click="confirmSaveTemplate">保存</a-button>
        </div>
      </a-modal>

      <!-- 编辑模板弹窗（编辑字段） -->
      <a-modal v-model="showEditTemplateDialog" title="编辑模板" width="600px" @cancel="cancelEditTemplate">
        <div class="dialog-container">
          <div style="margin-bottom: 16px;">
            <a-input v-model="editingTemplateName" placeholder="请输入模板名称" size="small" style="width: 100%;" />
          </div>
          <div style="font-size: 13px; color: #606266; margin-bottom: 8px;">配置模板字段：</div>
          <div class="demo-box edit-template-fields no-border" style="align-items: center; justify-content: center; gap: 16px; flex-wrap: nowrap;">
            <div class="transfer-panel">
              <div class="transfer-panel-header">
                <span>可选 ({{ editTemplateLeftCount }})</span>
              </div>
              <div class="transfer-panel-body">
                <div v-for="field in editTemplateLeftData" :key="field.field" class="transfer-panel-item" @click="addFieldToTemplate(field.field)">
                  <span>{{ field.label }}</span>
                  <span style="color: #FC6732;">→</span>
                </div>
                <div v-if="editTemplateLeftData.length === 0" class="transfer-empty">无数据</div>
              </div>
            </div>
            <div class="transfer-buttons">
              <a-button type="primary" size="small" @click="addAllFieldsToTemplate">≫</a-button>
              <a-button type="primary" size="small" :disabled="editingTemplateFields.length <= 1" @click="removeAllFieldsFromTemplate">≪</a-button>
            </div>
            <div class="transfer-panel">
              <div class="transfer-panel-header">
                <span>已选 ({{ editTemplateRightCount }})</span>
              </div>
              <div class="transfer-panel-body">
                <div v-for="(field, index) in editTemplateRightData" :key="field.field" class="transfer-panel-item draggable" draggable="true" @dragstart="onEditTemplateDragStart($event, index)" @dragover.prevent @drop="onEditTemplateDrop($event, index)">
                  <span class="drag-handle">☰</span>
                  <span class="item-label">{{ field.label }}</span>
                  <div class="item-actions">
                    <a-icon type="up" class="sort-arrow" v-if="index > 0" @click.stop="moveTemplateFieldUp(index)" />
                    <a-icon type="down" class="sort-arrow" v-if="index < editTemplateRightData.length - 1" @click.stop="moveTemplateFieldDown(index)" />
                    <span class="remove-btn" :class="{ disabled: editingTemplateFields.length <= 1 }" @click.stop="editingTemplateFields.length > 1 ? removeFieldFromTemplate(field.field) : null">✕</span>
                  </div>
                </div>
                <div v-if="editTemplateRightData.length === 0" class="transfer-empty">无数据</div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <a-button @click="cancelEditTemplate">取消</a-button>
          <a-button type="primary" @click="confirmEditTemplate">保存</a-button>
        </div>
      </a-modal>

      <!-- 进度条组件 -->
      <div class="section">
        <h2 class="section-title">进度条 Progress 演示</h2>

        <div class="demo-section">
          <div class="demo-title">线性进度条</div>
          <div class="demo-box" style="flex-direction: column; align-items: flex-start;">
            <a-progress :percent="percentage" style="width: 400px; margin-bottom: 16px;" />
            <a-progress :percent="80" status="success" style="width: 400px; margin-bottom: 16px;" />
            <a-progress :percent="50" status="exception" style="width: 400px; margin-bottom: 16px;" />
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">圆形进度条</div>
          <div class="demo-box">
            <a-progress type="circle" :percent="75" :width="100" />
            <a-progress type="circle" :percent="80" status="success" :width="100" style="margin-left: 20px;" />
            <a-progress type="circle" :percent="30" status="exception" :width="100" style="margin-left: 20px;" />
          </div>
        </div>
      </div>

      <!-- 标签组件 -->
      <div class="section">
        <h2 class="section-title">标签 Tag 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础标签</div>
          <div class="demo-box">
            <a-tag color="primary">主要标签</a-tag>
            <a-tag color="success">成功标签</a-tag>
            <a-tag color="warning">警告标签</a-tag>
            <a-tag color="error">危险标签</a-tag>
            <a-tag>默认标签</a-tag>
          </div>
        </div>
      </div>

      <!-- 分割线组件 -->
      <div class="section">
        <h2 class="section-title">分割线 Divider 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础分割线</div>
          <div class="demo-box">
            <p>上方内容</p>
            <a-divider />
            <p>下方内容</p>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">带文案分割线</div>
          <div class="demo-box">
            <p>上方内容</p>
            <a-divider>居中文案</a-divider>
            <p>下方内容</p>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">虚线分割线</div>
          <div class="demo-box">
            <p>上方内容</p>
            <a-divider dashed />
            <p>下方内容</p>
          </div>
        </div>

        <div class="demo-section">
          <div class="demo-title">垂直分割线</div>
          <div class="demo-box">
            <span>左侧内容</span>
            <a-divider type="vertical" />
            <span>中间内容</span>
            <a-divider type="vertical" />
            <span>右侧内容</span>
          </div>
        </div>
      </div>

      <!-- 标签页 -->
      <div class="section">
        <h2 class="section-title">标签页 Tabs 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础用法</div>
          <div class="demo-box tabs-basic-box" style="display: block;">
            <a-tabs v-model="activeTab" :animated="{ inkBar: true, tabPane: false }">
              <a-tab-pane key="first" tab="用户管理">用户管理</a-tab-pane>
              <a-tab-pane key="second" tab="配置管理">配置管理</a-tab-pane>
              <a-tab-pane key="third" tab="角色管理">角色管理</a-tab-pane>
              <a-tab-pane key="fourth" tab="任务管理">任务管理</a-tab-pane>
            </a-tabs>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">卡片风格</div>
          <div class="demo-box" style="display: block;">
            <a-tabs v-model="activeTab2" type="card">
              <a-tab-pane key="first" tab="用户管理">用户管理</a-tab-pane>
              <a-tab-pane key="second" tab="配置管理">配置管理</a-tab-pane>
              <a-tab-pane key="third" tab="角色管理">角色管理</a-tab-pane>
              <a-tab-pane key="fourth" tab="任务管理">任务管理</a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>

      <!-- 步骤条 -->
      <div class="section">
        <h2 class="section-title">步骤条 Steps 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础步骤条（品牌色 #FC6732）</div>
          <div class="demo-box" style="flex-direction: column; align-items: flex-start; gap: 20px;">
            <div class="custom-steps">
              <div class="custom-step" :class="currentStep >= 0 ? (currentStep > 0 ? 'is-finish' : 'is-process') : ''">
                <div class="custom-step__line custom-step__line--right"></div>
                <div class="custom-step__icon">{{ currentStep > 0 ? '✓' : '1' }}</div>
                <div class="custom-step__title">步骤1</div>
              </div>
              <div class="custom-step" :class="currentStep >= 1 ? (currentStep > 1 ? 'is-finish' : 'is-process') : ''">
                <div class="custom-step__line custom-step__line--left"></div>
                <div class="custom-step__line custom-step__line--right"></div>
                <div class="custom-step__icon">{{ currentStep > 1 ? '✓' : '2' }}</div>
                <div class="custom-step__title">步骤2</div>
              </div>
              <div class="custom-step" :class="currentStep >= 2 ? 'is-process' : ''">
                <div class="custom-step__line custom-step__line--left"></div>
                <div class="custom-step__icon">{{ currentStep > 2 ? '✓' : '3' }}</div>
                <div class="custom-step__title">步骤3</div>
              </div>
            </div>
            <a-space>
              <a-button @click="prevStep" :disabled="currentStep === 0">上一步</a-button>
              <a-button type="primary" @click="nextStep" :disabled="currentStep === 2">下一步</a-button>
            </a-space>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">带图标步骤条</div>
          <div class="demo-box" style="flex-direction: column; align-items: flex-start;">
            <div class="custom-steps">
              <div class="custom-step is-finish">
                <div class="custom-step__line custom-step__line--right"></div>
                <div class="custom-step__icon">✓</div>
                <div class="custom-step__title">步骤1</div>
              </div>
              <div class="custom-step is-process">
                <div class="custom-step__line custom-step__line--left"></div>
                <div class="custom-step__line custom-step__line--right"></div>
                <div class="custom-step__icon">✎</div>
                <div class="custom-step__title">步骤2</div>
              </div>
              <div class="custom-step">
                <div class="custom-step__line custom-step__line--left"></div>
                <div class="custom-step__icon">3</div>
                <div class="custom-step__title">步骤3</div>
              </div>
            </div>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">垂直步骤条</div>
          <div class="demo-box" style="flex-direction: row; align-items: flex-start;">
            <div class="custom-steps custom-steps--vertical" style="width: 200px;">
              <div class="custom-step is-finish" style="margin-bottom: 24px;">
                <div class="custom-step__icon">✓</div>
                <div class="custom-step__content">
                  <div class="custom-step__title">填写信息</div>
                  <div class="custom-step__desc">填写基本信息</div>
                </div>
              </div>
              <div class="custom-step is-process" style="margin-bottom: 24px;">
                <div class="custom-step__icon">✎</div>
                <div class="custom-step__content">
                  <div class="custom-step__title">上传材料</div>
                  <div class="custom-step__desc">上传所需材料</div>
                </div>
              </div>
              <div class="custom-step">
                <div class="custom-step__icon">3</div>
                <div class="custom-step__content">
                  <div class="custom-step__title">提交审核</div>
                  <div class="custom-step__desc">等待审核结果</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 数据展示 Badge/Avatar/Skeleton -->
      <div class="section">
        <h2 class="section-title">数据展示 Tag/Badge/Avatar/Skeleton 演示</h2>
        <div class="demo-section">
          <div class="demo-title">徽标 Badge</div>
          <div class="demo-box">
            <a-badge :count="5">
              <a-button>消息</a-button>
            </a-badge>
            <a-badge :count="100" :max="99">
              <a-button>消息</a-button>
            </a-badge>
            <a-badge is-dot>
              <a-button>新消息</a-button>
            </a-badge>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">头像 Avatar</div>
          <div class="demo-box">
            <a-avatar>User</a-avatar>
            <a-avatar :size="60">User</a-avatar>
            <a-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" />
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">骨架屏 Skeleton</div>
          <div class="demo-box" style="flex-direction: column; align-items: flex-start;">
            <a-skeleton :rows="3" active></a-skeleton>
          </div>
        </div>
      </div>

      <!-- 时间线 -->
      <div class="section">
        <h2 class="section-title">时间线 Timeline 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础时间线</div>
          <div class="demo-box">
            <a-timeline>
              <a-timeline-item color="#0DD78D">2024-01-15 14:30 - 完成项目需求分析</a-timeline-item>
              <a-timeline-item color="#0DD78D">2024-01-16 09:00 - 团队讨论技术方案</a-timeline-item>
              <a-timeline-item color="#FC6732">2024-01-17 16:45 - 开始编写代码</a-timeline-item>
              <a-timeline-item color="#0DD78D">2024-01-18 11:20 - 完成功能开发</a-timeline-item>
            </a-timeline>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">时间线节点状态</div>
          <div class="demo-box">
            <a-timeline>
              <a-timeline-item color="#0DD78D">已完成 - 需求评审通过</a-timeline-item>
              <a-timeline-item color="#FC6732">进行中 - 开发阶段</a-timeline-item>
              <a-timeline-item color="#FEAE4D">待处理 - 测试阶段</a-timeline-item>
              <a-timeline-item color="#8D8E99">未开始 - 上线部署</a-timeline-item>
            </a-timeline>
          </div>
        </div>
      </div>

      <!-- 树 -->
      <div class="section">
        <h2 class="section-title">树 Tree 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础/可勾选/默认展开</div>
          <div class="demo-box">
            <a-tree
              :data="treeData"
              :expanded-keys="expandedKeys"
              :auto-expand-parent="autoExpandParent"
              checkable
              @expand="onExpand"
            />
          </div>
        </div>
      </div>

      <!-- 统计组件 -->
      <div class="section">
        <h2 class="section-title">统计组件 Statistic 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础用法</div>
          <div class="demo-box" style="display: block;">
            <a-row :gutter="16">
              <a-col :span="6">
                <a-statistic title="日活跃用户数" :value="268500" />
              </a-col>
              <a-col :span="6">
                <a-statistic title="男女比例" suffix="/100" :value="138" />
              </a-col>
              <a-col :span="6">
                <a-statistic title="总交易额" prefix="¥" :value="172000" />
              </a-col>
              <a-col :span="6">
                <a-statistic title="反馈数量" :value="562" suffix="条" />
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">卡片用法</div>
          <div class="demo-box" style="display: block;">
            <a-row :gutter="16">
              <a-col :span="8">
                <div class="statistic-card">
                  <a-statistic title="日活跃用户数" :value="98500" />
                  <div class="statistic-footer">
                    <span>较昨日</span>
                    <span class="green">24% ↑</span>
                  </div>
                </div>
              </a-col>
              <a-col :span="8">
                <div class="statistic-card">
                  <a-statistic title="月活跃用户数" :value="693700" />
                  <div class="statistic-footer">
                    <span>环比上月</span>
                    <span class="red">12% ↓</span>
                  </div>
                </div>
              </a-col>
              <a-col :span="8">
                <div class="statistic-card">
                  <a-statistic title="今日新增交易" :value="72000" prefix="¥" />
                  <div class="statistic-footer">
                    <span>较昨日</span>
                    <span class="green">16% ↑</span>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>

      <!-- 分段控制器 -->
      <div class="section">
        <h2 class="section-title">分段控制器组件 Segmented 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础用法</div>
          <div class="demo-box">
            <a-radio-group v-model="segmentedValue" button-style="solid">
              <a-radio-button value="日">日</a-radio-button>
              <a-radio-button value="周">周</a-radio-button>
              <a-radio-button value="月">月</a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">自定义样式</div>
          <div class="demo-box">
            <a-radio-group v-model="segmentedValue" button-style="solid">
              <a-radio-button value="日">日</a-radio-button>
              <a-radio-button value="周">周</a-radio-button>
              <a-radio-button value="月">月</a-radio-button>
            </a-radio-group>
          </div>
        </div>
      </div>

      <!-- 锚点组件 -->
      <div class="section">
        <h2 class="section-title">锚点组件 Anchor 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础用法</div>
          <div class="demo-box">
            <a-anchor>
              <a-anchor-link href="#基础用法" title="基础用法" />
              <a-anchor-link href="#水平模式" title="水平模式" />
              <a-anchor-link href="#垂直模式" title="垂直模式" />
              <a-anchor-link href="#自定义激活颜色" title="自定义激活颜色" />
            </a-anchor>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">垂直模式</div>
          <div class="demo-box" style="display: flex;">
            <div style="width: 200px; margin-right: 40px;">
              <a-anchor>
                <a-anchor-link href="#section1" title="第一节" />
                <a-anchor-link href="#section2" title="第二节" />
                <a-anchor-link href="#section3" title="第三节" />
                <a-anchor-link href="#section4" title="第四节" />
              </a-anchor>
            </div>
            <div style="flex: 1; height: 300px; overflow-y: auto; padding: 0 20px; border: 1px solid #E8E9EB; border-radius: 8px;">
              <h3 id="section1">第一节内容</h3>
              <p style="line-height: 2;">这里是第一节的内容，包含很多文字，用于演示锚点的滚动效果。</p>
              <h3 id="section2">第二节内容</h3>
              <p style="line-height: 2;">这里是第二节的内容，包含很多文字，用于演示锚点的滚动效果。</p>
              <h3 id="section3">第三节内容</h3>
              <p style="line-height: 2;">这里是第三节的内容，包含很多文字，用于演示锚点的滚动效果。</p>
              <h3 id="section4">第四节内容</h3>
              <p style="line-height: 2;">这里是第四节的内容，包含很多文字，用于演示锚点的滚动效果。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 文字提示 -->
      <div class="section">
        <h2 class="section-title">文字提示组件 Tooltip 演示</h2>
        <div class="demo-section">
          <div class="demo-title">基础用法</div>
          <div class="demo-box">
            <a-tooltip title="这是提示文字">
              <a-button>鼠标悬停显示提示</a-button>
            </a-tooltip>
            <a-tooltip title="上方提示" placement="top">
              <a-button>上方</a-button>
            </a-tooltip>
            <a-tooltip title="下方提示" placement="bottom">
              <a-button>下方</a-button>
            </a-tooltip>
            <a-tooltip title="左侧提示" placement="left">
              <a-button>左侧</a-button>
            </a-tooltip>
            <a-tooltip title="右侧提示" placement="right">
              <a-button>右侧</a-button>
            </a-tooltip>
          </div>
        </div>
      </div>

      <!-- 消息提示 -->
      <div class="section">
        <h2 class="section-title">消息提示 Message 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础提示</div>
          <div class="demo-box">
            <a-button @click="showMessage('success')">成功</a-button>
            <a-button @click="showMessage('warning')">警告</a-button>
            <a-button @click="showMessage('error')">错误</a-button>
            <a-button @click="showMessage('info')">信息</a-button>
          </div>
        </div>
      </div>

      <!-- 通知提醒 -->
      <div class="section">
        <h2 class="section-title">通知提醒 Notification 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础通知</div>
          <div class="demo-box">
            <a-button @click="showNotification('success')">成功通知</a-button>
            <a-button @click="showNotification('info')">信息通知</a-button>
            <a-button @click="showNotification('warning')">警告通知</a-button>
            <a-button @click="showNotification('error')">错误通知</a-button>
          </div>
        </div>
      </div>

      <!-- 气泡确认框 -->
      <div class="section">
        <h2 class="section-title">气泡确认框 Popconfirm 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础确认框</div>
          <div class="demo-box">
            <a-popconfirm title="确定要删除这条记录吗？" ok-text="确定" cancel-text="取消" @confirm="handleConfirm">
              <a-button type="primary">点击确认</a-button>
            </a-popconfirm>
          </div>
        </div>
      </div>

      <!-- 对话框 -->
      <div class="section">
        <h2 class="section-title">对话框 Modal 演示</h2>

        <div class="demo-section">
          <div class="demo-title">基础对话框</div>
          <div class="demo-box">
            <a-button type="primary" @click="showModal = true">打开对话框</a-button>
          </div>
        </div>
      </div>

      <!-- 抽屉 -->
      <div class="section">
        <h2 class="section-title">抽屉 Drawer 演示</h2>

        <div class="demo-section">
          <div class="demo-title">左侧/右侧/底部（带按钮）</div>
          <div class="demo-box">
            <a-button @click="drawerVisible1 = true">左侧抽屉</a-button>
            <a-button @click="drawerVisible2 = true">右侧抽屉</a-button>
            <a-button @click="drawerVisible3 = true">底部抽屉</a-button>
          </div>
        </div>
        <div class="demo-section">
          <div class="demo-title">预登记抽屉（带表单）</div>
          <div class="demo-box">
            <a-button type="primary" @click="preDrawerVisible = true">
              <a-icon type="plus" /> 新建账户
            </a-button>
          </div>
        </div>
      </div>

      <!-- 预登记抽屉（官方示例） -->
      <a-drawer
        title="新建账户"
        :width="720"
        :visible="preDrawerVisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onPreDrawerClose"
      >
        <a-form :form="preForm" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="姓名">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [{ required: true, message: '请输入姓名' }],
                    },
                  ]"
                  placeholder="请输入姓名"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="网址">
                <a-input
                  v-decorator="[
                    'url',
                    {
                      rules: [{ required: true, message: '请输入网址' }],
                    },
                  ]"
                  style="width: 100%"
                  addon-before="http://"
                  addon-after=".com"
                  placeholder="请输入网址"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="负责人">
                <a-select
                  v-decorator="[
                    'owner',
                    {
                      rules: [{ required: true, message: '请选择负责人' }],
                    },
                  ]"
                  placeholder="请选择负责人"
                >
                  <a-select-option value="xiao">笑笑傅</a-select-option>
                  <a-select-option value="mao">毛毛周</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="类型">
                <a-select
                  v-decorator="[
                    'type',
                    {
                      rules: [{ required: true, message: '请选择类型' }],
                    },
                  ]"
                  placeholder="请选择类型"
                >
                  <a-select-option value="private">私密</a-select-option>
                  <a-select-option value="public">公开</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="审批人">
                <a-select
                  v-decorator="[
                    'approver',
                    {
                      rules: [{ required: true, message: '请选择审批人' }],
                    },
                  ]"
                  placeholder="请选择审批人"
                >
                  <a-select-option value="jack">马云</a-select-option>
                  <a-select-option value="tom">刘强东</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="日期时间">
                <a-date-picker
                  v-decorator="[
                    'dateTime',
                    {
                      rules: [{ required: true, message: '请选择日期时间' }],
                    },
                  ]"
                  style="width: 100%"
                  :get-popup-container="trigger => trigger.parentNode"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item label="描述">
                <a-textarea
                  v-decorator="[
                    'description',
                    {
                      rules: [{ required: true, message: '请输入描述' }],
                    },
                  ]"
                  :rows="4"
                  placeholder="请输入描述"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-button :style="{ marginRight: '8px' }" @click="onPreDrawerClose">取消</a-button>
          <a-button type="primary" :loading="preSubmitting" @click="onPreDrawerSubmit">提交</a-button>
        </div>
      </a-drawer>
      
      <!-- 左侧抽屉 -->
      <a-drawer
        title="左侧抽屉"
        :width="500"
        :visible="drawerVisible1"
        :body-style="{ paddingBottom: '80px' }"
        @close="drawerVisible1 = false"
        placement="left"
      >
        <div class="drawer-container">
          <div class="drawer-body">
            <div class="drawer-body-content">
              <p>这是中部内容区域</p>
              <p>可以放置表单、列表等内容</p>
              <a-input placeholder="请输入内容" style="margin-top: 16px;"></a-input>
            </div>
          </div>
          <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
              zIndex: 1,
            }"
          >
            <a-button :style="{ marginRight: '8px' }" @click="drawerVisible1 = false">取消</a-button>
            <a-button type="primary" @click="drawerVisible1 = false">确定</a-button>
          </div>
        </div>
      </a-drawer>

      <!-- 右侧抽屉 -->
      <a-drawer
        title="右侧抽屉"
        :width="500"
        :visible="drawerVisible2"
        :body-style="{ paddingBottom: '80px' }"
        @close="drawerVisible2 = false"
        placement="right"
      >
        <div class="drawer-container">
          <div class="drawer-body">
            <div class="drawer-body-content">
              <p>这是中部内容区域</p>
              <p>可以放置表单、列表等内容</p>
              <a-input placeholder="请输入内容" style="margin-top: 16px;"></a-input>
            </div>
          </div>
          <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
              zIndex: 1,
            }"
          >
            <a-button :style="{ marginRight: '8px' }" @click="drawerVisible2 = false">取消</a-button>
            <a-button type="primary" @click="drawerVisible2 = false">确定</a-button>
          </div>
        </div>
      </a-drawer>

      <!-- 底部抽屉 -->
      <a-drawer
        title="底部抽屉"
        :height="300"
        :visible="drawerVisible3"
        :body-style="{ paddingBottom: '80px' }"
        @close="drawerVisible3 = false"
        placement="bottom"
      >
        <div class="drawer-container">
          <div class="drawer-body">
            <div class="drawer-body-content">
              <p>这是中部内容区域</p>
              <p>可以放置表单、列表等内容</p>
              <a-input placeholder="请输入内容" style="margin-top: 16px;"></a-input>
            </div>
          </div>
          <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
              zIndex: 1,
            }"
          >
            <a-button :style="{ marginRight: '8px' }" @click="drawerVisible3 = false">取消</a-button>
            <a-button type="primary" @click="drawerVisible3 = false">确定</a-button>
          </div>
        </div>
      </a-drawer>

      <!-- VXE-Table 表格组件 -->
      <div class="section">
        <h2 class="section-title">VXE-Table 表格组件演示</h2>

        <!-- 基础表格 -->
        <div class="demo-section">
          <div class="demo-title">基础表格（小表格）</div>
          <div class="demo-box">
            <div class="table-container">
              <vxe-grid
                ref="tableRef"
                :data="tableDataPage"
                :columns="tableColumns"
                :toolbar-config="tableToolbarConfig"
                :pager-config="tablePagerConfig"
                :import-config="tableImportConfig"
                :export-config="tableExportConfig"
                :print-config="tablePrintConfig"
                :resizable-config="resizableConfig"
                border
                size="small"
                show-overflow="title"
                :stripe="false"
                :loading="tableLoading"
                :row-config="{ isHover: true }"
                @page-change="handlePageChange($event, 'base')"
                @toolbar-button-click="handleToolbarButtonClick"
              >
              <template v-slot:tableAction="{ row }">
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableEdit(row)">编辑</a-button>
                  <span class="table-action-separator"></span>
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableView(row)">查看</a-button>
                  <span class="table-action-separator"></span>
                  <a-popconfirm title="确定要删除这条数据吗？" ok-text="删除" cancel-text="取消" @confirm="handleTableDelete(row)">
                    <a-button type="link" class="table-action-btn no-underline-btn">删除</a-button>
                  </a-popconfirm>
                </template>
              </vxe-grid>
            </div>
          </div>
        </div>

        <!-- 单选表格 -->
        <div class="demo-section">
          <div class="demo-title">单选表格</div>
          <div class="demo-box">
            <div class="table-container">
              <vxe-grid
                ref="radioTableRef"
                :data="radioTableDataPage"
                :columns="radioTableColumns"
                :toolbar-config="radioTableToolbarConfig"
                :pager-config="radioTablePagerConfig"
                :import-config="tableImportConfig"
                :export-config="tableExportConfig"
                :print-config="tablePrintConfig"
                :resizable-config="resizableConfig"
                border
                size="small"
                show-overflow="title"
                :stripe="false"
                :loading="radioTableLoading"
                :radio-config="{ highlight: true }"
                :row-config="{ isHover: true, isCurrent: true }"
                @page-change="handlePageChange($event, 'radio')"
                @toolbar-button-click="handleToolbarButtonClick"
              >
                <template v-slot:tableAction="{ row }">
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableEdit(row)">编辑</a-button>
                  <span class="table-action-separator"></span>
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableView(row)">查看</a-button>
                  <span class="table-action-separator"></span>
                  <a-popconfirm title="确定要删除这条数据吗？" ok-text="删除" cancel-text="取消" @confirm="handleTableDelete(row)">
                    <a-button type="link" class="table-action-btn no-underline-btn">删除</a-button>
                  </a-popconfirm>
                </template>
              </vxe-grid>
            </div>
          </div>
        </div>

        <!-- 多选表格 -->
        <div class="demo-section">
          <div class="demo-title">多选表格</div>
          <div class="demo-box">
            <div class="table-container">
              <vxe-grid
                ref="checkboxTableRef"
                :data="checkboxTableDataPage"
                :columns="checkboxTableColumns"
                :toolbar-config="checkboxTableToolbarConfig"
                :pager-config="checkboxTablePagerConfig"
                :import-config="tableImportConfig"
                :export-config="tableExportConfig"
                :print-config="tablePrintConfig"
                :resizable-config="resizableConfig"
                border
                size="small"
                show-overflow="title"
                :stripe="false"
                :loading="checkboxTableLoading"
                :checkbox-config="{ highlight: true, reserve: true }"
                :row-config="{ isHover: true, isCurrent: true }"
                @page-change="handlePageChange($event, 'checkbox')"
                @toolbar-button-click="handleToolbarButtonClick"
              >
                <template v-slot:tableAction="{ row }">
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableEdit(row)">编辑</a-button>
                  <span class="table-action-separator"></span>
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableView(row)">查看</a-button>
                  <span class="table-action-separator"></span>
                  <a-popconfirm title="确定要删除这条数据吗？" ok-text="删除" cancel-text="取消" @confirm="handleTableDelete(row)">
                    <a-button type="link" class="table-action-btn no-underline-btn">删除</a-button>
                  </a-popconfirm>
                </template>
              </vxe-grid>
            </div>
          </div>
        </div>

        <!-- 展开表格 -->
        <div class="demo-section">
          <div class="demo-title">展开表格</div>
          <div class="demo-box">
            <div class="table-container">
              <vxe-grid
                ref="expandTableRef"
                :data="expandTableDataPage"
                :columns="expandTableColumns"
                :toolbar-config="expandTableToolbarConfig"
                :pager-config="expandTablePagerConfig"
                :import-config="tableImportConfig"
                :export-config="tableExportConfig"
                :print-config="tablePrintConfig"
                :resizable-config="resizableConfig"
                border
                size="small"
                show-overflow="title"
                :stripe="false"
                :loading="expandTableLoading"
                :expand-config="{ padding: true }"
                :row-config="{ isHover: true, isCurrent: true }"
                @page-change="handlePageChange($event, 'expand')"
                @toolbar-button-click="handleToolbarButtonClick"
              >
                <template v-slot:expand_content="{ row }">
                  <div class="expand-content">
                    <vxe-grid
                      :data="getChildTableData(row)"
                      :columns="expandChildColumns"
                      border
                      size="small"
                      show-overflow="title"
                      :row-config="{ isHover: true, isCurrent: true }"
                    />
                  </div>
                </template>
                <template v-slot:tableAction="{ row }">
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableEdit(row)">编辑</a-button>
                  <span class="table-action-separator"></span>
                  <a-button type="link" class="table-action-btn no-underline-btn" @click="handleTableView(row)">查看</a-button>
                  <span class="table-action-separator"></span>
                  <a-popconfirm title="确定要删除这条数据吗？" ok-text="删除" cancel-text="取消" @confirm="handleTableDelete(row)">
                    <a-button type="link" class="table-action-btn no-underline-btn">删除</a-button>
                  </a-popconfirm>
                </template>
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 表格抽屉表单 -->
    <a-drawer
      :visible="tableDrawerVisible"
      @close="tableDrawerVisible = false"
      :title="tableDrawerTitle"
      placement="right"
      :width="720"
      :body-style="{ paddingBottom: '80px' }"
      :destroy-on-close="true"
    >
      <template v-if="tableFormMode === 'view'">
        <div style="margin-bottom: 16px;">
          <h4 style="margin: 0 0 12px 0; color: #1B1C33; font-size: 14px; font-weight: 600;">基本信息</h4>
          <a-card :bordered="false" style="border-radius: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);">
            <a-row :gutter="16">
              <a-col :span="12" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">姓名</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.name }}</div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">年龄</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.age }}</div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">性别</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.gender }}</div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">部门</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.department }}</div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">职位</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.position }}</div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">手机号</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.phone }}</div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">邮箱</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.email }}</div>
              </a-col>
              <a-col :span="24" style="margin-bottom: 12px;">
                <div style="color: #8D8E99; font-size: 14px;">地址</div>
                <div style="color: #1B1C33; font-size: 14px; margin-top: 4px;">{{ tableFormData.address }}</div>
              </a-col>
            </a-row>
          </a-card>
        </div>
      </template>
      <template v-else>
        <a-form :layout="'vertical'">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="姓名">
                <a-input v-model="tableFormData.name" placeholder="请输入姓名" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="年龄">
                <a-input v-model="tableFormData.age" placeholder="请输入年龄" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="性别">
                <a-select v-model="tableFormData.gender" placeholder="请选择性别">
                  <a-select-option value="男">男</a-select-option>
                  <a-select-option value="女">女</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="部门">
                <a-input v-model="tableFormData.department" placeholder="请输入部门" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="职位">
                <a-input v-model="tableFormData.position" placeholder="请输入职位" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="手机号">
                <a-input v-model="tableFormData.phone" placeholder="请输入手机号" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="邮箱">
                <a-input v-model="tableFormData.email" placeholder="请输入邮箱" />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="地址">
                <a-input v-model="tableFormData.address" placeholder="请输入地址" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </template>
      <div
        v-if="tableFormMode !== 'view'"
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="tableDrawerVisible = false">取消</a-button>
        <a-button type="primary" :loading="tableSubmitting" @click="handleTableSave">{{ tableFormMode === 'edit' ? '保存' : '确定' }}</a-button>
      </div>
    </a-drawer>

    <!-- Modal对话框 -->
    <a-modal v-model:visible="showModal" title="对话框标题" @ok="showModal = false">
      <p>这是对话框内容</p>
    </a-modal>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'App',
  data() {
    return {
      // 中文语言包
      zhCN,
      
      // 输入框
      inputValue: '',
      textareaValue: '',
      
      // 选择器
      selectValue: undefined,
      multiSelectValue: [],
      
      // 单选复选
      radioValue: '1',
      checkboxList: [],
      
      // 开关
      switchValue: true,
      
      // 评分
      rateValue: 3,
      
      // 滑块
      sliderValue: 50,
      sliderRange: [20, 80],
      sliderMarks: { 0: '0', 50: '50', 100: '100' },
      
      // 按钮加载
      buttonLoading: false,
      
      // 表单布局
      formLayout: 'horizontal',
      
      // 拖拽排序索引
      dragIndex: null,
      
      // 级联选择器
      cascaderValue: [],
      cascaderValueLeaf: [],
      cascaderValueMulti: [],
      cascaderOptions: [
        { value: 'zhejiang', label: '浙江', children: [
          { value: 'hangzhou', label: '杭州' },
          { value: 'ningbo', label: '宁波' }
        ]},
        { value: 'jiangsu', label: '江苏', children: [
          { value: 'nanjing', label: '南京' },
          { value: 'suzhou', label: '苏州' }
        ]}
      ],
      
      // 开关
      switchValue: true,
      switchValue2: false,
      
      // 数字输入框
      inputNumberValue: 1,
      inputNumberValue2: 2,
      inputNumberValue3: 0,
      
      // 颜色选择器
      colorValue: '#FC6732',
      
      // 上传组件
      fileList: [
        {
          uid: '1',
          name: 'xxx.png',
          status: 'done',
          response: 'Server Error 500',
          url: 'http://www.baidu.com/xxx.png',
        },
        {
          uid: '2',
          name: 'yyy.png',
          status: 'done',
          url: 'http://www.baidu.com/yyy.png',
        },
        {
          uid: '3',
          name: 'zzz.png',
          status: 'error',
          response: 'Server Error 500',
          url: 'http://www.baidu.com/zzz.png',
        },
      ],
      fileListDrag: [],
      fileListImage: [
        {
          uid: '-1',
          name: 'xxx.png',
          status: 'done',
          url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        },
        {
          uid: '-2',
          name: 'yyy.png',
          status: 'done',
          url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        },
      ],
      fileListWall: [
        {
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        },
        {
          uid: '-2',
          name: 'image.png',
          status: 'done',
          url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        },
      ],
      previewVisible: false,
      previewImage: '',
      
      // 时间选择器
      timeValue: null,
      timeRangeValue: null,
      
      // 日期选择器
      dateValue: null,
      weekValue: null,
      monthValue: null,
      dateRangeValue: null,
      
      // 穿梭框
      transferData: [],
      transferLeftData: [
        { key: '1', label: '选项1' },
        { key: '2', label: '选项2' },
        { key: '3', label: '选项3' },
        { key: '4', label: '选项4' },
        { key: '5', label: '选项5' }
      ],
      transferRightData: [],
      transferSearchLeft: '',
      transferSearchRight: '',

      // 筛选条件
      filterAllFields: [
        { field: 'name', label: '姓名', type: 'input', placeholder: '请输入姓名', span: 4 },
        { field: 'phone', label: '手机号', type: 'input', placeholder: '请输入手机号', span: 4 },
        { field: 'email', label: '邮箱', type: 'input', placeholder: '请输入邮箱', span: 4 },
        { field: 'idCard', label: '身份证号', type: 'input', placeholder: '请输入身份证号', span: 4 },
        { field: 'status', label: '状态', type: 'select', placeholder: '请选择状态', span: 4, options: [{label: '全部', value: ''}, {label: '正常', value: '正常'}, {label: '异常', value: '异常'}] },
        { field: 'role', label: '角色', type: 'select', placeholder: '请选择角色', span: 4, options: [{label: '全部', value: ''}, {label: '管理员', value: '管理员'}, {label: '普通用户', value: '普通用户'}] },
        { field: 'department', label: '部门', type: 'select', placeholder: '请选择部门', span: 4, options: [{label: '全部', value: ''}, {label: '研发部', value: '研发部'}, {label: '市场部', value: '市场部'}, {label: '运营部', value: '运营部'}] },
        { field: 'position', label: '岗位', type: 'select', placeholder: '请选择岗位', span: 4, options: [{label: '全部', value: ''}, {label: '经理', value: '经理'}, {label: '主管', value: '主管'}, {label: '专员', value: '专员'}] },
        { field: 'gender', label: '性别', type: 'select', placeholder: '请选择性别', span: 4, options: [{label: '全部', value: ''}, {label: '男', value: '男'}, {label: '女', value: '女'}] },
        { field: 'education', label: '学历', type: 'select', placeholder: '请选择学历', span: 4, options: [{label: '全部', value: ''}, {label: '本科', value: '本科'}, {label: '硕士', value: '硕士'}, {label: '博士', value: '博士'}] },
        { field: 'entryDate', label: '入职日期', type: 'daterange', placeholder: '选择日期', span: 8 },
        { field: 'createTime', label: '创建时间', type: 'daterange', placeholder: '选择日期', span: 8 },
        { field: 'updateTime', label: '更新时间', type: 'daterange', placeholder: '选择日期', span: 8 },
        { field: 'loginTime', label: '最后登录', type: 'daterange', placeholder: '选择日期', span: 8 },
        { field: 'province', label: '省份', type: 'select', placeholder: '请选择省份', span: 4, options: [{label: '全部', value: ''}, {label: '北京', value: '北京'}, {label: '上海', value: '上海'}, {label: '广东', value: '广东'}] },
        { field: 'city', label: '城市', type: 'select', placeholder: '请选择城市', span: 4, options: [{label: '全部', value: ''}, {label: '深圳', value: '深圳'}, {label: '广州', value: '广州'}, {label: '杭州', value: '杭州'}] },
        { field: 'address', label: '详细地址', type: 'input', placeholder: '请输入详细地址', span: 4 },
        { field: 'zipCode', label: '邮编', type: 'input', placeholder: '请输入邮编', span: 4 },
        { field: 'remark', label: '备注', type: 'input', placeholder: '请输入备注', span: 4 },
        { field: 'source', label: '来源', type: 'select', placeholder: '请选择来源', span: 4, options: [{label: '全部', value: ''}, {label: '官网', value: '官网'}, {label: '推荐', value: '推荐'}, {label: '招聘', value: '招聘'}] }
      ],
      selectedFilterFields: ['name', 'phone', 'status', 'department'],
      filterData: { name: undefined, phone: undefined, email: undefined, idCard: undefined, status: undefined, role: undefined, department: undefined, position: undefined, gender: undefined, education: undefined, entryDate: [], createTime: [], updateTime: [], loginTime: [], province: undefined, city: undefined, address: undefined, zipCode: undefined, remark: undefined, source: undefined },
      filterExpanded: false,
      filterConfigVisible: false,
      tempFilterFields: [],
      filterSearchLeft: '',
      filterSearchRight: '',
      filterDragIndex: -1,
      filterTemplates: [
        { name: '默认模板', fields: ['name', 'phone', 'status'] }
      ],
      tempFilterTemplates: [],
      showSaveTemplate: false,
      showEditTemplateDialog: false,
      templateName: '',
      editingTemplateIdx: null,
      editingTemplateName: '',
      editingTemplateFields: [],
      editTemplateDragIndex: -1,

      // 标签页
      activeTab: 'first',
      activeTab2: 'first',
      
      // 步骤条
      currentStep: 0,
      
      // 骨架屏
      skeletonLoading: true,
      
      // 树
      treeData: [
        {
          title: '一级菜单',
          key: '0-0',
          children: [
            { title: '二级菜单1', key: '0-0-0', children: [
              { title: '三级菜单1', key: '0-0-0-0' },
              { title: '三级菜单2', key: '0-0-0-1' }
            ]},
            { title: '二级菜单2', key: '0-0-1' }
          ]
        },
        {
          title: '一级菜单2',
          key: '0-1',
          children: [
            { title: '二级菜单3', key: '0-1-0' }
          ]
        }
      ],
      expandedKeys: ['0-0', '0-1'],
      autoExpandParent: true,
      
      // 分段控制器
      segmentedValue: 'Daily',
      segmentedOptions: ['Daily', 'Weekly', 'Monthly'],
      cascaderFilter(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
      },
      
      // 表格相关
      tableLoading: false,
      radioTableLoading: false,
      checkboxTableLoading: false,
      expandTableLoading: false,
      tableDrawerVisible: false,
      tableDrawerTitle: '新增',
      tableFormMode: 'add',
      tableSubmitting: false,
      tableFormData: {
        id: null,
        name: '',
        age: '',
        gender: '',
        department: '',
        position: '',
        phone: '',
        email: '',
        address: ''
      },

      // VXE-Table 表格数据
      tableData: [
        { id: 1, name: '张三', age: 28, gender: '男', department: '技术部', position: '前端工程师', phone: '13800138001', email: 'zhangsan@example.com', address: '北京市朝阳区建国路88号' },
        { id: 2, name: '李四', age: 32, gender: '女', department: '产品部', position: '产品经理', phone: '13800138002', email: 'lisi@example.com', address: '上海市浦东新区陆家嘴金融中心' },
        { id: 3, name: '王五', age: 25, gender: '男', department: '设计部', position: 'UI设计师', phone: '13800138003', email: 'wangwu@example.com', address: '广州市天河区珠江新城' },
        { id: 4, name: '赵六', age: 30, gender: '女', department: '运营部', position: '运营专员', phone: '13800138004', email: 'zhaoliu@example.com', address: '深圳市南山区科技园' },
        { id: 5, name: '钱七', age: 27, gender: '男', department: '技术部', position: '后端工程师', phone: '13800138005', email: 'qianqi@example.com', address: '杭州市西湖区文三路' },
        { id: 6, name: '孙八', age: 35, gender: '女', department: '人事部', position: 'HR经理', phone: '13800138006', email: 'sunba@example.com', address: '成都市高新区天府大道' },
        { id: 7, name: '周九', age: 29, gender: '男', department: '财务部', position: '财务主管', phone: '13800138007', email: 'zhoujiu@example.com', address: '南京市鼓楼区中山路' },
        { id: 8, name: '吴十', age: 26, gender: '女', department: '市场部', position: '市场专员', phone: '13800138008', email: 'wushi@example.com', address: '武汉市江汉区解放大道' },
        { id: 9, name: '郑十一', age: 31, gender: '男', department: '技术部', position: '测试工程师', phone: '13800138009', email: 'zhengshiyi@example.com', address: '西安市雁塔区科技路' },
        { id: 10, name: '冯十二', age: 24, gender: '女', department: '客服部', position: '客服主管', phone: '13800138010', email: 'fengshier@example.com', address: '重庆市渝北区新南路' },
        { id: 11, name: '陈十三', age: 33, gender: '男', department: '技术部', position: '架构师', phone: '13800138011', email: 'chenshisan@example.com', address: '天津市滨海新区第三大街' },
        { id: 12, name: '褚十四', age: 28, gender: '女', department: '法务部', position: '法务专员', phone: '13800138012', email: 'chushisi@example.com', address: '苏州市姑苏区观前街' },
        { id: 13, name: '卫十五', age: 30, gender: '男', department: '采购部', position: '采购经理', phone: '13800138013', email: 'weishiwu@example.com', address: '长沙市岳麓区麓山南路' },
        { id: 14, name: '蒋十六', age: 27, gender: '女', department: '公关部', position: '公关专员', phone: '13800138014', email: 'jiangshiliu@example.com', address: '郑州市金水区花园路' },
        { id: 15, name: '沈十七', age: 34, gender: '男', department: '技术部', position: '运维工程师', phone: '13800138015', email: 'shenshiqi@example.com', address: '青岛市市南区香港中路' },
        { id: 16, name: '韩十八', age: 29, gender: '女', department: '培训部', position: '培训专员', phone: '13800138016', email: 'hanshiba@example.com', address: '大连市中山区人民路' },
        { id: 17, name: '杨十九', age: 26, gender: '男', department: '研发部', position: '算法工程师', phone: '13800138017', email: 'yangshijiu@example.com', address: '济南市历下区泉城路' },
        { id: 18, name: '朱二十', age: 31, gender: '女', department: '商务部', position: '商务经理', phone: '13800138018', email: 'zhuer@example.com', address: '哈尔滨市南岗区红军街' },
        { id: 19, name: '秦二一', age: 28, gender: '男', department: '技术部', position: '数据工程师', phone: '13800138019', email: 'qineryi@example.com', address: '沈阳市和平区三好街' },
        { id: 20, name: '尤二二', age: 25, gender: '女', department: '设计部', position: '交互设计师', phone: '13800138020', email: 'youer@example.com', address: '长春市朝阳区同志街' },
        { id: 21, name: '许二三', age: 32, gender: '男', department: '项目部', position: '项目经理', phone: '13800138021', email: 'xueersan@example.com', address: '福州市鼓楼区五一路' },
        { id: 22, name: '何二四', age: 29, gender: '女', department: '质量部', position: 'QA工程师', phone: '13800138022', email: 'heersi@example.com', address: '厦门市思明区鹭江道' },
        { id: 23, name: '吕二五', age: 27, gender: '男', department: '技术部', position: '移动端工程师', phone: '13800138023', email: 'lver@example.com', address: '昆明市五华区东风东路' },
        { id: 24, name: '施二六', age: 33, gender: '女', department: '行政部', position: '行政主管', phone: '13800138024', email: 'shiliu@example.com', address: '兰州市城关区东方红广场' },
        { id: 25, name: '张二七', age: 30, gender: '男', department: '技术部', position: '安全工程师', phone: '13800138025', email: 'zhangqi@example.com', address: '太原市小店区学府街' },
        { id: 26, name: '孔二八', age: 26, gender: '女', department: '品牌部', position: '品牌经理', phone: '13800138026', email: 'kongba@example.com', address: '合肥市蜀山区黄山路' },
        { id: 27, name: '曹二九', age: 28, gender: '男', department: '技术部', position: 'DevOps工程师', phone: '13800138027', email: 'caojiu@example.com', address: '石家庄市长安区中山路' },
        { id: 28, name: '严三十', age: 31, gender: '女', department: '战略部', position: '战略分析师', phone: '13800138028', email: 'yanshi@example.com', address: '南昌市东湖区八一大道' },
        { id: 29, name: '华三十一', age: 29, gender: '男', department: '技术部', position: '前端架构师', phone: '13800138029', email: 'huashi@example.com', address: '贵阳市南明区中华南路' },
        { id: 30, name: '金三十二', age: 27, gender: '女', department: '市场部', position: '市场分析师', phone: '13800138030', email: 'jinshier@example.com', address: '海口市龙华区海秀路' },
        { id: 31, name: '魏三三', age: 34, gender: '男', department: '技术部', position: '技术总监', phone: '13800138031', email: 'weisansan@example.com', address: '拉萨市城关区北京路' },
        { id: 32, name: '陶三四', age: 25, gender: '女', department: '客服部', position: '客服专员', phone: '13800138032', email: 'taoliu@example.com', address: '银川市兴庆区解放街' },
        { id: 33, name: '姜三五', age: 30, gender: '男', department: '采购部', position: '采购专员', phone: '13800138033', email: 'jiangwu@example.com', address: '西宁市城西区五四西路' },
        { id: 34, name: '戚三六', age: 28, gender: '女', department: '设计部', position: '视觉设计师', phone: '13800138034', email: 'qiliu@example.com', address: '乌鲁木齐市天山区中山路' },
        { id: 35, name: '谢三七', age: 32, gender: '男', department: '运营部', position: '运营经理', phone: '13800138035', email: 'xieqi@example.com', address: '呼和浩特市新城区新华大街' },
        { id: 36, name: '邹三八', age: 26, gender: '女', department: '人事部', position: '招聘专员', phone: '13800138036', email: 'zouba@example.com', address: '南宁市青秀区民族大道' },
        { id: 37, name: '柏三九', age: 29, gender: '男', department: '技术部', position: '全栈工程师', phone: '13800138037', email: 'baijiu@example.com', address: '北京市海淀区中关村大街' },
        { id: 38, name: '水四十', age: 27, gender: '女', department: '财务部', position: '会计', phone: '13800138038', email: 'shiershi@example.com', address: '上海市静安区南京西路' },
        { id: 39, name: '窦四一', age: 31, gender: '男', department: '技术部', position: '云架构师', phone: '13800138039', email: 'doushi@example.com', address: '广州市越秀区环市东路' },
        { id: 40, name: '章四二', age: 28, gender: '女', department: '法务部', position: '法务经理', phone: '13800138040', email: 'zhangsi@example.com', address: '深圳市福田区福华路' },
        { id: 41, name: '苏四三', age: 25, gender: '男', department: '市场部', position: 'BD经理', phone: '13800138041', email: 'sushi@example.com', address: '杭州市拱墅区莫干山路' },
        { id: 42, name: '潘四四', age: 33, gender: '女', department: '产品部', position: '高级产品经理', phone: '13800138042', email: 'panwu@example.com', address: '成都市锦江区春熙路' },
        { id: 43, name: '葛四十五', age: 29, gender: '男', department: '技术部', position: '区块链工程师', phone: '13800138043', email: 'gewu@example.com', address: '武汉市武昌区中南路' },
        { id: 44, name: '奚四十六', age: 27, gender: '女', department: '培训部', position: '培训经理', phone: '13800138044', email: 'xiliu@example.com', address: '南京市玄武区中山东路' },
        { id: 45, name: '范四十七', age: 30, gender: '男', department: '技术部', position: 'AI工程师', phone: '13800138045', email: 'fanqi@example.com', address: '重庆市江北区观音桥' },
        { id: 46, name: '彭四十八', age: 26, gender: '女', department: '商务部', position: '商务专员', phone: '13800138046', email: 'pengba@example.com', address: '天津市和平区南京路' },
        { id: 47, name: '郎四十九', age: 28, gender: '男', department: '项目部', position: '项目助理', phone: '13800138047', email: 'langjiu@example.com', address: '西安市碑林区长安路' },
        { id: 48, name: '鲁五十', age: 32, gender: '女', department: '质量部', position: '质量经理', phone: '13800138048', email: 'luwu@example.com', address: '青岛市崂山区海尔路' },
        { id: 49, name: '韦四十九', age: 24, gender: '男', department: '技术部', position: '实习生', phone: '13800138049', email: 'weijiu@example.com', address: '济南市市中区共青团路' },
        { id: 50, name: '昌五十', age: 29, gender: '女', department: '客服部', position: '客服经理', phone: '13800138050', email: 'changshi@example.com', address: '福州市台江区五一中路' }
      ],

      // VXE-Table 分页配置（基础表格）
      tablePagerConfig: {
        enabled: true,
        background: true,
        pageSizes: [10, 20, 50, 100],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        layout: 'Total, Sizes, PrevPage, Number, NextPage, FullJump'
      },

      // 单选表格分页配置
      radioTablePagerConfig: {
        enabled: true,
        background: true,
        pageSizes: [10, 20, 50, 100],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        layout: 'Total, Sizes, PrevPage, Number, NextPage, FullJump'
      },

      // 多选表格分页配置
      checkboxTablePagerConfig: {
        enabled: true,
        background: true,
        pageSizes: [10, 20, 50, 100],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        layout: 'Total, Sizes, PrevPage, Number, NextPage, FullJump'
      },

      // 展开表格分页配置
      expandTablePagerConfig: {
        enabled: true,
        background: true,
        pageSizes: [10, 20, 50, 100],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        layout: 'Total, Sizes, PrevPage, Number, NextPage, FullJump'
      },

      // VXE-Table 代理配置（本地模式关闭 proxy）
      proxyConfig: {
        enabled: false,
        ajax: {
          query: () => Promise.resolve([])
        }
      },

      // VXE-Table 列宽拖拽配置
      resizableConfig: {
        enabled: true,
        minWidth: 40,
        maxWidth: 0,
        isDblclickAutoWidth: true
      },

      // VXE-Table 工具栏配置
      tableToolbarConfig: {
        enabled: true,
        buttons: [
          { code: 'add', name: '新增', status: 'primary', icon: '', click: () => this.handleAdd() }
        ],
        import: { enabled: true },
        export: { enabled: true },
        print: { enabled: true },
        zoom: { enabled: true },
        refresh: { enabled: true, queryMethod: () => this.handleRefresh() },
        custom: { enabled: true }
      },

      // 单选表格工具栏配置
      radioTableToolbarConfig: {
        enabled: true,
        buttons: [
          { code: 'add', name: '新增', status: 'primary', icon: '', click: () => this.handleAdd() }
        ],
        import: { enabled: true },
        export: { enabled: true },
        print: { enabled: true },
        zoom: { enabled: true },
        refresh: { enabled: true, queryMethod: () => this.handleRadioRefresh() },
        custom: { enabled: true }
      },

      // 多选表格工具栏配置
      checkboxTableToolbarConfig: {
        enabled: true,
        buttons: [
          { code: 'add', name: '新增', status: 'primary', icon: '', click: () => this.handleAdd() }
        ],
        import: { enabled: true },
        export: { enabled: true },
        print: { enabled: true },
        zoom: { enabled: true },
        refresh: { enabled: true, queryMethod: () => this.handleCheckboxRefresh() },
        custom: { enabled: true }
      },

      // 展开表格工具栏配置
      expandTableToolbarConfig: {
        enabled: true,
        buttons: [
          { code: 'add', name: '新增', status: 'primary', icon: '', click: () => this.handleAdd() }
        ],
        import: { enabled: true },
        export: { enabled: true },
        print: { enabled: true },
        zoom: { enabled: true },
        refresh: { enabled: true, queryMethod: () => this.handleExpandRefresh() },
        custom: { enabled: true }
      },

      // VXE-Table 导入配置
      tableImportConfig: {
        enabled: true,
        remote: false,
        modes: ['insert', 'update'],
        types: ['xlsx', 'csv']
      },

      // VXE-Table 导出配置
      tableExportConfig: {
        enabled: true,
        modes: ['current', 'selected', 'all'],
        types: ['xlsx', 'csv', 'xml', 'html', 'txt', 'pdf']
      },

      // VXE-Table 打印配置
      tablePrintConfig: {
        columns: [
          { index: 0 }, { index: 1 }, { index: 2 }, { index: 3 }, { index: 4 },
          { index: 5 }, { index: 6 }, { index: 7 }, { index: 8 }, { index: 9 }
        ]
      },

      // VXE-Table 基础表格列定义
      tableColumns: [
        { type: 'seq', title: '序号', width: 60, align: 'center', resizable: true },
        { field: 'name', title: '姓名', minWidth: 100, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'age', title: '年龄', width: 80, sortable: true, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'gender', title: '性别', width: 80, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'department', title: '部门', minWidth: 120, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'position', title: '职位', minWidth: 120, showOverflow: 'title', resizable: true },
        { field: 'phone', title: '手机号', width: 130, showOverflow: 'title', resizable: true },
        { field: 'email', title: '邮箱', minWidth: 180, showOverflow: 'title', resizable: true },
        { field: 'address', title: '地址', minWidth: 200, showOverflow: 'title', resizable: true },
        {
          title: '操作',
          fixed: 'right',
          align: 'center',
          width: 180,
          slots: { default: 'tableAction' }
        }
      ],

      // VXE-Table 单选表格列定义
      radioTableColumns: [
        { type: 'radio', width: 60, align: 'center' },
        { type: 'seq', title: '序号', width: 60, align: 'center', resizable: true },
        { field: 'name', title: '姓名', minWidth: 100, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'age', title: '年龄', width: 80, sortable: true, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'gender', title: '性别', width: 80, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'department', title: '部门', minWidth: 120, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'position', title: '职位', minWidth: 120, showOverflow: 'title', resizable: true },
        { field: 'phone', title: '手机号', width: 130, showOverflow: 'title', resizable: true },
        { field: 'email', title: '邮箱', minWidth: 180, showOverflow: 'title', resizable: true },
        { field: 'address', title: '地址', minWidth: 200, showOverflow: 'title', resizable: true },
        {
          title: '操作',
          fixed: 'right',
          align: 'center',
          width: 180,
          slots: { default: 'tableAction' }
        }
      ],

      // VXE-Table 多选表格列定义
      checkboxTableColumns: [
        { type: 'checkbox', width: 60, align: 'center' },
        { type: 'seq', title: '序号', width: 60, align: 'center', resizable: true },
        { field: 'name', title: '姓名', minWidth: 100, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'age', title: '年龄', width: 80, sortable: true, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'gender', title: '性别', width: 80, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'department', title: '部门', minWidth: 120, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'position', title: '职位', minWidth: 120, showOverflow: 'title', resizable: true },
        { field: 'phone', title: '手机号', width: 130, showOverflow: 'title', resizable: true },
        { field: 'email', title: '邮箱', minWidth: 180, showOverflow: 'title', resizable: true },
        { field: 'address', title: '地址', minWidth: 200, showOverflow: 'title', resizable: true },
        {
          title: '操作',
          fixed: 'right',
          align: 'center',
          width: 180,
          slots: { default: 'tableAction' }
        }
      ],

      // VXE-Table 展开表格列定义
      expandTableColumns: [
        { type: 'expand', width: 60, align: 'center', slots: { content: 'expand_content' } },
        { type: 'seq', title: '序号', width: 60, align: 'center', resizable: true },
        { field: 'name', title: '姓名', minWidth: 100, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'age', title: '年龄', width: 80, sortable: true, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'gender', title: '性别', width: 80, align: 'center', showOverflow: 'title', resizable: true },
        { field: 'department', title: '部门', minWidth: 120, sortable: true, showOverflow: 'title', resizable: true },
        { field: 'position', title: '职位', minWidth: 120, showOverflow: 'title', resizable: true },
        { field: 'phone', title: '手机号', width: 130, showOverflow: 'title', resizable: true },
        { field: 'email', title: '邮箱', minWidth: 180, showOverflow: 'title', resizable: true },
        { field: 'address', title: '地址', minWidth: 200, showOverflow: 'title', resizable: true },
        {
          title: '操作',
          fixed: 'right',
          align: 'center',
          width: 180,
          slots: { default: 'tableAction' }
        }
      ],

      // VXE-Table 展开子表格列定义
      expandChildColumns: [
        { type: 'seq', title: '序号', width: 60, align: 'center' },
        { field: 'field', title: '自定义字段', minWidth: 120, showOverflow: 'title' },
        { field: 'value', title: '字段值', minWidth: 200, showOverflow: 'title' },
        { field: 'remark', title: '备注', width: 150, showOverflow: 'title' }
      ],
      
      // Modal和Drawer
      showModal: false,
      drawerVisible1: false,
      drawerVisible2: false,
      drawerVisible3: false,
      // 预登记抽屉（官方示例）
      preDrawerVisible: false,
      preSubmitting: false,
      preForm: this.$form ? this.$form.createForm(this) : { getFieldDecorator: () => () => null, setFieldsValue: () => {}, validateFields: (cb) => cb && cb(null, {}) },
      
      // 进度条百分比
      percentage: 60
    }
  },
  computed: {
    // VXE-Table 分页后的表格数据
    tableDataPage() {
      const start = (this.tablePagerConfig.currentPage - 1) * this.tablePagerConfig.pageSize
      const end = start + this.tablePagerConfig.pageSize
      this.tablePagerConfig.total = this.tableData.length
      return this.tableData.slice(start, end)
    },

    // 单选表格分页后的数据
    radioTableDataPage() {
      const start = (this.radioTablePagerConfig.currentPage - 1) * this.radioTablePagerConfig.pageSize
      const end = start + this.radioTablePagerConfig.pageSize
      this.radioTablePagerConfig.total = this.tableData.length
      return this.tableData.slice(start, end)
    },

    // 多选表格分页后的数据
    checkboxTableDataPage() {
      const start = (this.checkboxTablePagerConfig.currentPage - 1) * this.checkboxTablePagerConfig.pageSize
      const end = start + this.checkboxTablePagerConfig.pageSize
      this.checkboxTablePagerConfig.total = this.tableData.length
      return this.tableData.slice(start, end)
    },

    // 展开表格分页后的数据
    expandTableDataPage() {
      const start = (this.expandTablePagerConfig.currentPage - 1) * this.expandTablePagerConfig.pageSize
      const end = start + this.expandTablePagerConfig.pageSize
      this.expandTablePagerConfig.total = this.tableData.length
      return this.tableData.slice(start, end)
    },
    // 穿梭框计算属性
    filteredLeftData() {
      return this.transferLeftData.filter(item => 
        !this.transferRightData.find(r => r.key === item.key) &&
        item.label.toLowerCase().includes(this.transferSearchLeft.toLowerCase())
      )
    },
    filteredRightData() {
      return this.transferRightData.filter(item =>
        item.label.toLowerCase().includes(this.transferSearchRight.toLowerCase())
      )
    },
    leftCount() {
      return this.filteredLeftData.length
    },
    rightCount() {
      return this.filteredRightData.length
    },
    // 高级筛选穿梭框计算属性
    filterLeftData() {
      if (!this.filterAllFields) return []
      return this.filterAllFields.filter(f => !this.tempFilterFields.includes(f.field))
    },
    filterRightData() {
      if (!this.tempFilterFields) return []
      return this.tempFilterFields
        .map(field => this.filterAllFields.find(f => f.field === field))
        .filter(f => f)
    },
    filterFilteredLeftData() {
      if (!this.filterSearchLeft) return this.filterLeftData
      return this.filterLeftData.filter(f => f.label.toLowerCase().includes(this.filterSearchLeft.toLowerCase()))
    },
    filterFilteredRightData() {
      if (!this.filterSearchRight) return this.filterRightData
      return this.filterRightData.filter(f => f.label.toLowerCase().includes(this.filterSearchRight.toLowerCase()))
    },
    filterLeftCount() {
      return this.filterFilteredLeftData.length
    },
    filterRightCount() {
      return this.filterRightData.length
    },
    visibleFilterFields() {
      return this.selectedFilterFields
        .map(fieldName => this.filterAllFields.find(f => f.field === fieldName))
        .filter(f => f !== undefined)
    },
    isSingleRowFilter() {
      const fields = this.visibleFilterFields
      let spanCount = 0
      for (const field of fields) {
        spanCount += field.type === 'daterange' ? 12 : 6
      }
      return spanCount <= 18
    },
    filterFieldRows() {
      const fields = this.visibleFilterFields
      if (!this.filterExpanded) {
        let spanCount = 0
        let index = 0
        for (let i = 0; i < fields.length; i++) {
          const span = fields[i].type === 'daterange' ? 12 : 6
          if (spanCount + span <= 24) {
            spanCount += span
            index = i + 1
          } else {
            break
          }
        }
        return [fields.slice(0, index)]
      }
      const rows = []
      let currentRow = []
      let currentSpan = 0
      for (const field of fields) {
        const span = field.type === 'daterange' ? 12 : 6
        if (currentSpan + span > 24 && currentRow.length > 0) {
          rows.push(currentRow)
          currentRow = [field]
          currentSpan = span
        } else {
          currentRow.push(field)
          currentSpan += span
        }
      }
      if (currentRow.length > 0) {
        rows.push(currentRow)
      }
      return rows
    },
    editTemplateLeftData() {
      if (!this.filterAllFields) return []
      return this.filterAllFields.filter(f => !this.editingTemplateFields.includes(f.field))
    },
    editTemplateRightData() {
      if (!this.editingTemplateFields) return []
      return this.editingTemplateFields
        .map(field => this.filterAllFields.find(f => f.field === field))
        .filter(f => f)
    },
    editTemplateLeftCount() {
      return this.filterAllFields.length - this.editingTemplateFields.length
    },
    editTemplateRightCount() {
      return this.editingTemplateFields.length
    }
  },
  created() {
    // VXE-Table 初始化
  },
  methods: {
    // 预登记抽屉 - 关闭
    onPreDrawerClose() {
      this.preDrawerVisible = false
      this.$nextTick(() => {
        if (this.preForm && this.preForm.resetFields) {
          this.preForm.resetFields()
        }
      })
    },
    // 预登记抽屉 - 提交（带校验）
    onPreDrawerSubmit() {
      if (!this.preForm || !this.preForm.validateFields) {
        this.$message.error('表单未初始化')
        return
      }
      this.preForm.validateFields((err, values) => {
        if (err) {
          this.$message.error('请填写完整的必填项')
          return
        }
        this.preSubmitting = true
        // 模拟提交
        setTimeout(() => {
          this.preSubmitting = false
          this.$message.success('提交成功：' + JSON.stringify(values))
          this.onPreDrawerClose()
        }, 600)
      })
    },

    // 消息提示
    showMessage(type) {
      this.$message[type](`这是一条${type}消息`)
    },
    
    // 通知提醒
    showNotification(type) {
      this.$notification[type]({
        message: '通知标题',
        description: '这是通知内容'
      })
    },
    
    // 确认操作
    handleConfirm() {
      this.$message.success('确认成功')
    },
    
    // 步骤条
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },
    nextStep() {
      if (this.currentStep < 2) {
        this.currentStep++
      }
    },
    
    // 树展开
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    
    // 穿梭框方法
    addItem(key) {
      const item = this.transferLeftData.find(i => i.key === key)
      if (item && !this.transferRightData.find(r => r.key === key)) {
        this.transferRightData.push(item)
      }
    },
    addAllItems() {
      this.filteredLeftData.forEach(item => {
        if (!this.transferRightData.find(r => r.key === item.key)) {
          this.transferRightData.push(item)
        }
      })
    },
    removeItem(key) {
      const index = this.transferRightData.findIndex(item => item.key === key)
      if (index > -1) {
        this.transferRightData.splice(index, 1)
      }
    },
    removeAllItems() {
      this.transferRightData = []
    },
    // 拖拽排序
    onDragStart(event, index) {
      this.dragIndex = index
      event.dataTransfer.effectAllowed = 'move'
    },
    onDrop(event, dropIndex) {
      event.preventDefault()
      if (this.dragIndex !== null && this.dragIndex !== dropIndex) {
        const item = this.transferRightData.splice(this.dragIndex, 1)[0]
        this.transferRightData.splice(dropIndex, 0, item)
      }
      this.dragIndex = null
    },
    moveUp(index) {
      if (index > 0) {
        const temp = this.transferRightData[index]
        this.$set(this.transferRightData, index, this.transferRightData[index - 1])
        this.$set(this.transferRightData, index - 1, temp)
      }
    },
    moveDown(index) {
      if (index < this.transferRightData.length - 1) {
        const temp = this.transferRightData[index]
        this.$set(this.transferRightData, index, this.transferRightData[index + 1])
        this.$set(this.transferRightData, index + 1, temp)
      }
    },
    
    // 筛选
    doFilter() {
      console.log('筛选条件:', this.filterData)
      this.$message.success('查询成功')
    },
    resetFilter() {
      Object.keys(this.filterData).forEach(key => {
        const isDateRange = ['createTime', 'entryDate', 'updateTime', 'loginTime'].includes(key)
        this.$set(this.filterData, key, isDateRange ? [] : undefined)
      })
      this.$message.info('已重置')
    },
    openFilterConfig() {
      this.tempFilterFields = [...this.selectedFilterFields]
      this.tempFilterTemplates = JSON.parse(JSON.stringify(this.filterTemplates))
      this.filterConfigVisible = true
    },
    addFilterField(field) {
      if (!this.tempFilterFields.includes(field)) {
        this.tempFilterFields.push(field)
      }
    },
    addAllFilterFields() {
      this.tempFilterFields = this.filterAllFields.map(f => f.field)
    },
    removeFilterField(field) {
      const idx = this.tempFilterFields.indexOf(field)
      if (idx > -1) {
        this.tempFilterFields.splice(idx, 1)
      }
    },
    removeAllFilterFields() {
      if (this.tempFilterFields.length > 1) {
        this.tempFilterFields = [this.tempFilterFields[0]]
      }
    },
    onFilterDragStart(evt, index) {
      this.filterDragIndex = index
      evt.dataTransfer.effectAllowed = 'move'
      evt.target.classList.add('dragging')
    },
    onFilterDrop(evt, targetIndex) {
      evt.target.classList.remove('dragging')
      if (this.filterDragIndex !== -1 && this.filterDragIndex !== targetIndex) {
        const items = [...this.tempFilterFields]
        const item = items[this.filterDragIndex]
        items.splice(this.filterDragIndex, 1)
        items.splice(targetIndex, 0, item)
        this.tempFilterFields = items
      }
      this.filterDragIndex = -1
    },
    moveFilterFieldUp(index) {
      if (index > 0) {
        const items = [...this.tempFilterFields]
        const temp = items[index]
        items[index] = items[index - 1]
        items[index - 1] = temp
        this.tempFilterFields = items
      }
    },
    moveFilterFieldDown(index) {
      if (index < this.tempFilterFields.length - 1) {
        const items = [...this.tempFilterFields]
        const temp = items[index]
        items[index] = items[index + 1]
        items[index + 1] = temp
        this.tempFilterFields = items
      }
    },
    onEditTemplateDragStart(event, index) {
      this.editTemplateDragIndex = index
      event.dataTransfer.effectAllowed = 'move'
      event.target.classList.add('dragging')
    },
    onEditTemplateDrop(event, targetIndex) {
      event.target.classList.remove('dragging')
      if (this.editTemplateDragIndex !== -1 && this.editTemplateDragIndex !== targetIndex) {
        const items = [...this.editingTemplateFields]
        const item = items[this.editTemplateDragIndex]
        items.splice(this.editTemplateDragIndex, 1)
        items.splice(targetIndex, 0, item)
        this.editingTemplateFields = items
      }
      this.editTemplateDragIndex = -1
    },
    applyFilterConfig() {
      this.selectedFilterFields = [...this.tempFilterFields]
      this.filterTemplates = JSON.parse(JSON.stringify(this.tempFilterTemplates))
      this.filterConfigVisible = false
      this.filterExpanded = false
      this.$message.success('筛选配置已更新')
    },
    showSaveTemplateMethod() {
      this.showSaveTemplate = true
      this.templateName = ''
    },
    confirmSaveTemplate() {
      if (!this.templateName || !this.templateName.trim()) {
        this.$message.warning('请输入模板名称')
        return
      }
      const fieldsToSave = [...this.tempFilterFields]
      if (fieldsToSave.length === 0) {
        this.$message.warning('模板至少需要一个筛选条件')
        return
      }
      this.tempFilterTemplates.push({ name: this.templateName.trim(), fields: fieldsToSave })
      this.showSaveTemplate = false
      this.templateName = ''
      this.$message.success('模板保存成功')
    },
    cancelSaveTemplate() {
      this.showSaveTemplate = false
      this.templateName = ''
    },
    applyTemplate(template) {
      if (template.fields.length === 0) {
        this.$message.warning('模板至少需要一个筛选条件')
        return
      }
      this.tempFilterFields = [...template.fields]
      this.$message.success('已选择模板：' + template.name + '，点击确定后生效')
    },
    editTemplate(idx) {
      this.editingTemplateIdx = idx
      this.editingTemplateName = this.tempFilterTemplates[idx].name
      this.editingTemplateFields = [...this.tempFilterTemplates[idx].fields]
      this.showEditTemplateDialog = true
    },
    confirmEditTemplate() {
      if (!this.editingTemplateName || !this.editingTemplateName.trim()) {
        this.$message.warning('请输入模板名称')
        return
      }
      if (this.editingTemplateFields.length === 0) {
        this.$message.warning('模板至少需要一个字段')
        return
      }
      this.tempFilterTemplates[this.editingTemplateIdx].name = this.editingTemplateName.trim()
      this.tempFilterTemplates[this.editingTemplateIdx].fields = [...this.editingTemplateFields]
      this.showEditTemplateDialog = false
      this.editingTemplateIdx = null
      this.editingTemplateName = ''
      this.editingTemplateFields = []
      this.$message.success('模板修改成功')
    },
    cancelEditTemplate() {
      this.showEditTemplateDialog = false
      this.editingTemplateIdx = null
      this.editingTemplateName = ''
      this.editingTemplateFields = []
    },
    removeFieldFromTemplate(field) {
      if (this.editingTemplateFields.length <= 1) {
        return
      }
      const idx = this.editingTemplateFields.indexOf(field)
      if (idx > -1) {
        this.editingTemplateFields.splice(idx, 1)
      }
    },
    deleteTemplate(index) {
      this.tempFilterTemplates.splice(index, 1)
      this.$message.success('模板已删除')
    },
    addFieldToTemplate(field) {
      if (!this.editingTemplateFields.includes(field)) {
        this.editingTemplateFields.push(field)
      }
    },
    addAllFieldsToTemplate() {
      this.editingTemplateFields = this.filterAllFields.map(f => f.field)
    },
    removeAllFieldsFromTemplate() {
      if (this.editingTemplateFields.length > 1) {
        this.editingTemplateFields = [this.editingTemplateFields[0]]
      }
    },
    moveTemplateFieldUp(index) {
      if (index > 0) {
        const items = [...this.editingTemplateFields]
        const temp = items[index]
        items[index] = items[index - 1]
        items[index - 1] = temp
        this.editingTemplateFields = items
      }
    },
    moveTemplateFieldDown(index) {
      if (index < this.editingTemplateFields.length - 1) {
        const items = [...this.editingTemplateFields]
        const temp = items[index]
        items[index] = items[index + 1]
        items[index + 1] = temp
        this.editingTemplateFields = items
      }
    },
    
    // 上传
    beforeUpload(file, fileList) {
      return false
    },
    beforeUploadDrag(file, fileList) {
      return false
    },
    beforeUploadImage(file, fileList) {
      return false
    },
    handleChange({ fileList: newFileList }) {
      this.fileList = newFileList
    },
    handleChangeDrag({ fileList: newFileList }) {
      this.fileListDrag = newFileList
    },
    handleChangeImage({ fileList: newFileList }) {
      this.fileListImage = newFileList
    },
    handleChangeWall({ fileList: newFileList }) {
      this.fileListWall = newFileList
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreviewWall(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    
    // VXE-Table 刷新（基础表格）
    handleRefresh() {
      return new Promise((resolve) => {
        this.tableLoading = true
        setTimeout(() => {
          this.tablePagerConfig.currentPage = 1
          this.tableLoading = false
          this.$message.success('刷新成功')
          resolve()
        }, 500)
      })
    },

    // 单选表格刷新
    handleRadioRefresh() {
      return new Promise((resolve) => {
        this.radioTableLoading = true
        setTimeout(() => {
          this.radioTablePagerConfig.currentPage = 1
          this.radioTableLoading = false
          this.$message.success('刷新成功')
          resolve()
        }, 500)
      })
    },

    // 多选表格刷新
    handleCheckboxRefresh() {
      return new Promise((resolve) => {
        this.checkboxTableLoading = true
        setTimeout(() => {
          this.checkboxTablePagerConfig.currentPage = 1
          this.checkboxTableLoading = false
          this.$message.success('刷新成功')
          resolve()
        }, 500)
      })
    },

    // 展开表格刷新
    handleExpandRefresh() {
      return new Promise((resolve) => {
        this.expandTableLoading = true
        setTimeout(() => {
          this.expandTablePagerConfig.currentPage = 1
          this.expandTableLoading = false
          this.$message.success('刷新成功')
          resolve()
        }, 500)
      })
    },

    // VXE-Table 工具栏按钮点击
    handleToolbarButtonClick({ code }) {
      if (code === 'add' || code === 'insert') {
        this.tableDrawerTitle = '新增'
        this.tableFormMode = 'add'
        this.tableFormData = { id: null, name: '', age: '', gender: '', department: '', position: '', phone: '', email: '', address: '' }
        this.tableDrawerVisible = true
      }
    },

    // VXE-Table 分页变化（支持不同表格独立分页）
    handlePageChange({ currentPage, pageSize }, type) {
      const configs = {
        base: this.tablePagerConfig,
        radio: this.radioTablePagerConfig,
        checkbox: this.checkboxTablePagerConfig,
        expand: this.expandTablePagerConfig
      }
      const config = configs[type]
      if (config) {
        config.currentPage = currentPage
        config.pageSize = pageSize
      }
    },

    // VXE-Table 获取子表格数据
    getChildTableData(row) {
      return [
        { field: '手机号', value: row.phone, remark: '主要联系方式' },
        { field: '邮箱', value: row.email, remark: '工作邮箱' },
        { field: '地址', value: row.address, remark: '现居地址' }
      ]
    },

    // VXE-Table 编辑行
    handleTableEdit(row) {
      this.tableFormMode = 'edit'
      this.tableDrawerTitle = '编辑'
      this.tableFormData = { ...row }
      this.tableDrawerVisible = true
    },

    // VXE-Table 查看行
    handleTableView(row) {
      this.tableFormMode = 'view'
      this.tableDrawerTitle = '查看详情'
      this.tableFormData = { ...row }
      this.tableDrawerVisible = true
    },

    // VXE-Table 删除行
    handleTableDelete(row) {
      const index = this.tableData.findIndex(item => item.id === row.id)
      if (index > -1) {
        this.tableData.splice(index, 1)
        this.$message.success('删除成功')
      }
    },

    // 表格新增（抽屉）
    handleTableAdd() {
      this.tableDrawerTitle = '新增'
      this.tableFormMode = 'add'
      this.tableFormData = { id: null, name: '', age: '', gender: '', department: '', position: '', phone: '', email: '', address: '' }
      this.tableDrawerVisible = true
    },

    // 导入
    handleImport() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.xlsx,.xls,.csv'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          this.$message.success(`已选择文件: ${file.name}`)
        }
      }
      input.click()
    },

    // 导出
    handleExport() {
      const headers = ['序号', '姓名', '年龄', '性别', '部门', '职位', '手机号', '邮箱', '地址']
      const rows = this.tableData.map((row, index) => [
        index + 1, row.name, row.age, row.gender, row.department, row.position, row.phone, row.email, row.address
      ])
      let csvContent = headers.join('\t') + '\n'
      rows.forEach(row => { csvContent += row.join('\t') + '\n' })
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '表格数据.csv'
      link.click()
      this.$message.success('导出成功')
    },

    // 打印
    handlePrint() {
      window.print()
    },

    // 刷新
    handleRefresh() {
      this.tableLoading = true
      setTimeout(() => {
        this.tableData = [...this.tableData]
        this.tableLoading = false
        this.$message.success('刷新成功')
      }, 500)
    },

    // 列配置
    handleConfig() {
      this.$message.info('列配置功能已触发')
    },

    // 保存表格表单
    handleTableSave() {
      if (this.tableFormMode === 'view') {
        this.tableDrawerVisible = false
        return
      }
      this.tableSubmitting = true
      setTimeout(() => {
        if (this.tableFormData.id) {
          const index = this.tableData.findIndex(item => item.id === this.tableFormData.id)
          if (index > -1) {
            this.tableData.splice(index, 1, { ...this.tableFormData })
            this.$message.success('编辑成功')
          }
        } else {
          const newId = Math.max(...this.tableData.map(item => item.id), 0) + 1
          this.tableData.push({ ...this.tableFormData, id: newId })
          this.$message.success('新增成功')
        }
        this.tableSubmitting = false
        this.tableDrawerVisible = false
      }, 500)
    },

    // 读取文件为文本
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    // 自定义行样式（悬停效果）
    customRow(record) {
      return {
        on: {
          mouseenter: () => {
            this.hoverRowKey = record.id
          },
          mouseleave: () => {
            this.hoverRowKey = null
          }
        },
        style: record.id === this.hoverRowKey ? { backgroundColor: '#F7F8FA' } : {}
      }
    }
  }
}
</script>
